export default {
  首页: "หน้าแรก",
  资产: "สินทรัพย์",
  币币: "สกุลเงิน",
  快捷买币: "ซื้อเหรียญอย่างรวดเร็ว",
  "支持多种方式购买，购买更简单":
    "รองรับการซื้อได้หลากหลายช่องทางทำให้ซื้อได้ง่ายขึ้น",
  语言设置: "ตั้งค่าภาษา",
  确认恢复: "ยืนยันการกู้คืน",
  "输入邮箱，方便我们联系您": "กรอกอีเมลของคุณเพื่อให้เราติดต่อคุณได้",
  划转: "โอนย้าย",
  行情: "คำพูด",
  "24H成交": "ข้อตกลง 24H",
  累计收益: "รายได้สะสม",
  充值时间: "เวลาเติมเงิน",
  到期时间: "วันที่หมดอายุ",
  数量: "ปริมาณ",
  操作: "ดำเนินงาน",
  资产信息: "ข้อมูลสินทรัพย์",
  复制地址: "คัดลอกที่อยู่",
  链名称: "ชื่อลูกโซ่",
  充值地址: "ที่อยู่เติมเงิน",
  收款地址: "ที่อยู่รับ",
  账单: "ใบแจ้งหนี้",
  提现金额: "จำนวนเงินที่ถอนออก",
  接收地址: "ที่อยู่รับ",
  交易密码: "รหัสผ่านการทำธุรกรรม",
  提现全部: "ถอนออกทั้งหมด",
  保存图片: "บันทึกรูปภาพ",
  输入您的交易密码: "ป้อนรหัสผ่านการทำธุรกรรมของคุณ",
  确定: "แน่นอน",
  地址: "ที่อยู่",
  注册时间: "เวลาลงทะเบียน",
  取消: "ยกเลิก",
  是否划转: "ว่าจะโอน",
  登录: "เข้าสู่ระบบ",
  我的地址: "ที่อยู่ของฉัน",
  登录密码和交易密码: "รหัสผ่านเข้าสู่ระบบและรหัสผ่านการทำธุรกรรม",
  注册: "ลงทะเบียน",
  密码: "รหัสผ่าน",
  设置密码: "ตั้งรหัสผ่าน",
  重复密码: "ทำซ้ำรหัสผ่าน",
  新密码: "รหัสผ่านใหม่",
  确认新密码: "ยืนยันรหัสผ่านใหม่",
  充值: "เติมเงิน",
  充值货币: "เติมเงินสกุลเงิน",
  合约账户充值: "เติมบัญชีสัญญา",
  账户充值: "เติมเงินบัญชี",
  其他: "อื่นๆ",
  我的邀请码: "รหัสเชิญของฉัน",
  提现: "ถอน",
  客服: "บริการลูกค้า",
  持有详情: "รายละเอียดการถือครอง",
  请输入内容: "กรุณาใส่เนื้อหา",
  邀请好友来领取奖励: "เชิญเพื่อนเพื่อรับรางวัล",
  复制链接: "คัดลอกลิงค์",
  重复设置新的密码: "ทำซ้ำเพื่อตั้งรหัสผ่านใหม่",
  保存: "บันทึก",
  我的: "ของฉัน",
  "邮箱/手机号": "อีเมล/เบอร์มือถือ",
  备注: "ข้อสังเกต",
  地址管理: "การจัดการที่อยู่",
  我的团队: "ทีมของฉัน",
  联系我们: "ติดต่อเรา",
  竭诚为您服务: "ขอแสดงความนับถือที่บริการของคุณ",
  提取收益: "ถอนเงิน",
  带给我的收益: "ประโยชน์แก่ข้าพเจ้า",
  添加: "เพิ่ม",
  名称: "ชื่อ",
  添加地址: "เพิ่มที่อยู่",
  修改地址: "เปลี่ยนที่อยู่",
  可提现: "ถอนได้",
  安全中心: "ศูนย์รักษาความปลอดภัย",
  收益划转: "ดำเนินการโอน",
  通知中心: "ศูนย์แจ้งเตือน",
  "累计收益:": "รายได้สะสม:",
  注册用户: "ผู้ใช้ที่ลงทะเบียน",
  奖励规则: "กฎการให้รางวัล",
  帮助反馈: "ช่วยติชม",
  邀请好友: "เชิญเพื่อน ๆ",
  恢复身份: "เรียกคืนข้อมูลประจำตัว",
  选择语言: "เลือกภาษา",
  设置新的密码: "ตั้งรหัสผ่านใหม่",
  暂无活动: "ยังไม่มีกิจกรรม",
  "月增长量(+)": "การเติบโตรายเดือน (+)",
  可提取: "สกัดได้",
  反馈类型: "ประเภทความคิดเห็น",
  赠送: "ของขวัญ",
  已经复制: "คัดลอกแล้ว",
  保存成功: "บันทึกเรียบร้อยแล้ว",
  划转成功: "โอนสำเร็จ",
  过期: "หมดอายุ",
  提交成功: "ส่งเรียบร้อยแล้ว",
  "服务器繁忙，稍后在试": "เซิร์ฟเวอร์ไม่ว่าง ลองใหม่ภายหลัง",
  全部: "ทั้งหมด",
  一级: "ระดับหนึ่ง",
  二级: "รอง",
  三级: "ระดับสาม",
  级: "ระดับ",
  删除成功: "ลบเรียบร้อยแล้ว",
  选择地址: "เลือกที่อยู่",
  不再提醒: "ไม่มีการแจ้งเตือน",
  "最小充值金额：": "จำนวนเงินเติมขั้นต่ำ:",
  选择币种: "เลือกสกุลเงิน",
  输入投资金额: "ใส่จำนวนเงินลงทุน",
  输入账户密码: "ป้อนรหัสผ่านบัญชี",
  投资: "ลงทุน",
  订单编号: "หมายเลขคำสั่งซื้อ",
  投资周期: "วัฏจักรการลงทุน",
  投资资金: "กองทุนรวมที่ลงทุน",
  投资时间: "เวลาการลงทุน",
  状态: "สถานะ",
  投资中: "การลงทุน",
  已到期: "กำลังจะหมดอายุ",
  暂无数据: "ไม่มีข้อมูล",
  转入: "โอนเข้า",
  邮箱: "จดหมาย",
  请输入邮箱: "กรุณาใส่อีเมลของคุณ",
  请输入格式正确的邮箱: "โปรดป้อนที่อยู่อีเมลในรูปแบบที่ถูกต้อง",
  请输入验证码: "กรุณากรอกรหัสยืนยัน",
  获取验证码: "รับรหัสยืนยัน",
  请输入邀请码: "กรุณากรอกรหัสเชิญ",
  今天: "วันนี้",
  昨天: "เมื่อวาน",
  最近七天: "เจ็ดวันที่ผ่านมา",
  邀请: "เชิญชวน",
  购买数量: "ปริมาณการซื้อ",
  产品详情: "รายละเอียดสินค้า",
  币种: "สกุลเงิน",
  利息币种: "สกุลเงินดอกเบี้ย",
  理财类型: "ประเภทของการจัดการทางการเงิน",
  产品费率: "อัตราสินค้า",
  进行中: "กำลังประมวลผล",
  每天: "ทุกวัน",
  请输入搜索关键词: "กรุณาใส่คำค้นหา",
  通知: "สังเกต",
  查看更多: "ดูเพิ่มเติม",
  理财宝: "สมบัติเงิน",
  周期: "รอบ",
  年利率: "อัตราดอกเบี้ยรายปี",
  更多产品: "ผลิตภัณฑ์เพิ่มเติม",
  灵活存取: "การเข้าถึงที่ยืดหยุ่น",
  稳定收益: "รายได้ที่มั่นคง",
  合约指南: "คู่มือสัญญา",
  资金划转出: "โอนเงินออก",
  矿池收益: "รายได้จากการขุดสระ",
  提现手续费: "ค่าธรรมเนียมการถอน",
  冻结资金: "ระงับกองทุน",
  解冻资金: "ยกเลิกการอายัดเงิน",
  闪兑支出: "ชำระเงินทันที",
  闪兑收入: "รับรายได้ทันที",
  闪兑手续费: "ค่าธรรมเนียมทันที",
  合约支出: "การจ่ายเงินตามสัญญา",
  合约收入: "รายได้ตามสัญญา",
  输入的金额不可大于可用金额: "จำนวนเงินที่ป้อนต้องไม่เกินจำนวนที่มีอยู่",
  全部兑换成功: "แลกเปลี่ยนทั้งหมดสำเร็จ",
  返回: "กลับ",
  查看历史: "ดูประวัติ",
  闪兑历史: "ประวัติแฟลช",
  支付: "จ่าย",
  获取: "รับ",
  时间: "เวลา",
  手续费: "ค่าธรรมเนียมการจัดการ",
  折扣: "การลดราคา",
  价格: "ราคา",
  逐仓: "โดดเดี่ยว",
  全仓: "ข้าม",
  市价委托: "คำสั่งของตลาด",
  限价委托: "คำสั่งจำกัด",
  请输入本金: "กรุณาใส่เงินต้น",
  请输入价格: "กรุณาใส่ราคา",
  "可做空/做多": "สั้น/ยาวได้",
  设置止盈止损: "TP/SL",
  止盈价: "Est. TP",
  止损价: "Est. SL",
  成本: "ค่าใช้จ่าย",
  做多: "ทำมากขึ้น",
  做空: "สั้น",
  仓位信息: "ข้อมูลตำแหน่ง",
  一键平仓: "ปิดทั้งหมด",
  永续: "ที่ยั่งยืน",
  浮动盈亏: "กำไรขาดทุนลอยตัว",
  平仓: "ปิดตำแหน่ง",
  反向开仓: "เปิดย้อนกลับ",
  一键撤销: "คลิกเดียวเลิกทำ",
  倍杠杆: "เลเวอเรจสองเท่า",
  执行价格: "ราคาการดำเนินการ",
  委托数量: "ปริมาณการสั่งซื้อ",
  保证金: "ระยะขอบ",
  成交价: "ราคาสุดท้าย",
  创建时间: "เวลาในการสร้าง",
  撤销: "ถอน",
  合约市场: "ตลาดสัญญา",
  交易方向: "ทิศทางการทำธุรกรรม",
  委托价格: "ราคาค่าคอมมิชชั่น",
  委托金额: "จำนวนเงินที่ได้รับมอบหมาย",
  资金费率: "อัตราเงินทุน",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "ค่าธรรมเนียมที่เกิดซ้ำซึ่งจ่ายโดยผู้ค้าระยะยาวและระยะสั้น ชำระทุก ๆ 8 ชั่วโมง",
  "资金费率为正，多方向空方支付资金费用。":
    "อัตราการระดมทุนเป็นบวก และฝั่งกระทิงจ่ายค่าธรรมเนียมการระดมทุนให้กับฝั่งชอร์ต",
  "资金费率为负，空方向多方支付资金费用。":
    "อัตราการระดมทุนเป็นค่าลบ และฝั่ง Short จ่ายค่าธรรมเนียมการระดมทุนให้กับฝั่ง Long",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "คุณแน่ใจหรือที่จะเปิดตำแหน่งย้อนกลับ? การเปิดตำแหน่งย้อนกลับจะใช้ตำแหน่งตรงกันข้ามกับช่วงเวลาปัจจุบันเพื่อซื้อ",
  "仓位止盈/止损": "ตำแหน่ง Take Profit/Stop Loss",
  合约名称: "ชื่อสัญญา",
  开仓价格: "ราคาเปิด",
  指数价格: "ราคาดัชนี",
  止盈设置: "ตั้งรับผลกำไร",
  请输入止盈价: "โปรดป้อนราคาทำกำไร",
  "当指数价格触达*时，将会触发委托平仓":
    "เมื่อราคาดัชนีถึง {0} คำสั่งจะถูกเรียกให้ปิดสถานะ",
  预计盈亏: "กำไรขาดทุนโดยประมาณ",
  当前仓位: "ตำแหน่งปัจจุบัน",
  平仓金额: "จำนวนเงินที่ปิด",
  仓位模式: "โหมดตำแหน่ง",
  全仓模式: "โหมดข้ามระยะขอบ",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "เงินที่มีอยู่ทั้งหมดในบัญชีสัญญาถือเป็นหลักประกันที่มีอยู่ เมื่อ Position Loss เกินยอดคงเหลือในบัญชี Position จะถูกชำระบัญชีและ Margin และ Position ทั้งหมดจะหายไป โปรดทราบว่า",
  逐仓模式: "โหมด Margin แบบแยก",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "มาร์จิ้นจำนวนหนึ่งในบัญชีสัญญาจะถูกจัดสรรให้กับตำแหน่ง หากการสูญเสียหลักประกันต่ำกว่าระดับการบำรุงรักษาตำแหน่งจะถูกชำระบัญชี ในโหมด Isolated Margin คุณสามารถเพิ่มและลดหลักประกันสำหรับตำแหน่งนี้ได้",
  "是否撤销？": "ถูกเพิกถอนหรือไม่",
  "是否一键撤销？": "เป็นไปได้ไหมที่จะยกเลิกด้วยการคลิกเพียงครั้งเดียว?",
  "是否一键平仓？": "เป็นไปได้ไหมที่จะปิดตำแหน่งด้วยการคลิกเพียงครั้งเดียว?",
  持仓保证金: "ระยะขอบ",
  风险率: "อัตราความเสี่ยง",
  未实现盈亏: "ยังไม่เกิดขึ้นจริง P&L",
  可用保证金: "มีระยะขอบ",
  净值: "รายได้สุทธิ",
  账户余额: "ยอดเงินในบัญชี",
  合约计算器: "เครื่องคิดเลขสัญญา",
  交易记录: "บันทึกการทำธุรกรรม",
  "*倍杠杆": "{num} เลเวอเรจสองเท่า",
  "平仓盈亏：": "ปิดกำไรและขาดทุน:",
  时间筛选: "ตัวกรองเวลา",
  仓位类型: "ประเภทตำแหน่ง",
  订单状态: "สถานะการสั่งซื้อ",
  订单类型: "ประเภทการสั่งซื้อ",
  平仓价格: "ราคาปิด",
  持仓数量: "จำนวนตำแหน่ง",
  "手续费(%)": "ค่าธรรมเนียม (%)",
  平仓时间: "เวลาปิด",
  平仓类型: "ประเภทการปิด",
  手动平仓: "ปิดตำแหน่งด้วยตนเอง",
  强制平仓: "การบังคับชำระบัญชี",
  近1天: "เกือบ 1 วัน",
  近7天: "7 วันที่ผ่านมา",
  近30天: "30 วันที่ผ่านมา",
  近180天: "เกือบ 180 วัน",
  持仓: "ตำแหน่ง",
  已取消: "ยกเลิก",
  分时: "การแบ่งเวลา",
  "24H额(USDT)": "จำนวนเงิน 24 ชั่วโมง (USDT)",
  "24H低": "ต่ำ 24 ชม",
  "24H量(BTC)": "จำนวน 24 ชั่วโมง (BTC)",
  "24H高": "สูง 24 ชม",
  "10秒": "10 วินาที",
  "30秒": "30 วินาที",
  "1分": "1 คะแนน",
  "3分": "3 คะแนน",
  "5分": "5 คะแนน",
  "30分": "30 คะแนน",
  "1小时": "1 ชั่วโมง",
  "4小时": "4 ชั่วโมง",
  "8小时": "8 ชั่วโมง",
  "1天": "1 วัน",
  "1周": "1 สัปดาห์",
  "1月": "มกราคม",
  单向持仓: "ตำแหน่งทางเดียว",
  杠杆: "คันโยก",
  仓位: "ตำแหน่ง",
  计算结果: "ผลการคำนวณ",
  盈亏: "กำไรและขาดทุน",
  收益率: "อัตราผลตอบแทน",
  计算结果仅供参考: "ผลการคำนวณใช้สำหรับการอ้างอิงเท่านั้น",
  成交后仓位大小: "ขนาดตำแหน่งหลังการทำธุรกรรม",
  "计算结果仅供参考,实际结果可能因费率差异":
    "ผลการคำนวณใช้สำหรับการอ้างอิงเท่านั้น ผลลัพธ์จริงอาจแตกต่างกันไปเนื่องจากความแตกต่างของอัตรา",
  目标价格: "ราคาเป้าหมาย",
  开始计算: "เริ่มคำนวณ",
  强平价格: "ราคาชำระบัญชี",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    " ก่อนเติมเงิน โปรดตรวจสอบชื่อสายการชาร์จอย่างระมัดระวัง ไม่สามารถเรียกค้นทรัพย์สินได้หากชาร์จผิด {0}จำนวนการเติมขั้นต่ำคือ {1}; แพลตฟอร์มจะไม่สามารถยืนยันบัญชีได้หากน้อยกว่าจำนวนนี้ โปรดทำ ห้ามเติมสินทรัพย์นอกเหนือจาก {2} ไปยังที่อยู่นี้ มิฉะนั้นคุณจะไม่สามารถเรียกคืนสินทรัพย์ได้ โปรดอย่าถอนเงินสดโดยตรงไปยังที่อยู่คราวด์ฟันดิ้งหรือ ICO และ Ping จะไม่แจกจ่ายเหรียญในนามของคุณ",
  "最小输入*": "อินพุตขั้นต่ำ{0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "จำนวนเงินที่ถอนขั้นต่ำคือ {0} และค่าธรรมเนียมการถอนจะถูกหักออกจากจำนวนเงินที่ถอนของคุณ โปรดยืนยันและตรวจสอบที่อยู่ที่รับเหรียญก่อนทำการถอนเหรียญ และอย่าถอน {1}ไปที่ที่อยู่อื่นที่ไม่ใช่ {2} มิฉะนั้นสินทรัพย์จะไม่ได้รับการกู้คืน โปรดอย่าถอนเงินโดยตรงจากที่อยู่คราวด์ฟันดิ้งหรือ ICO แพลตฟอร์มจะไม่จัดการการออกโทเค็น",
  退出登录: "ออกจากระบบ",
  加仓: "เพิ่มตำแหน่ง",
  新增仓位: "ตำแหน่งใหม่",
  输入加仓金额: "ป้อนจำนวนเงินที่เพิ่มขึ้น",
  "当前可用:": "สามารถใช้งานได้:",
  资产账单: "การเรียกเก็บเงินสินทรัพย์",
  保存二维码: "บันทึกคิวอาร์โค้ด",
  温馨提示: "เคล็ดลับชนิด",
  "请注意：您当前使用的网络": "หมายเหตุ: เครือข่ายปัจจุบันของคุณ",
  输入提现地址: "ป้อนที่อยู่การถอน",
  "可用金额：": "จำนวนที่มี:",
  输入资产密码: "ป้อนรหัสผ่านสินทรัพย์",
  可用手续费: "ค่าธรรมเนียมที่มีอยู่",
  "折扣%": "การลดราคา%",
  实扣手续费: "ค่าลดหย่อนตามจริง",
  实际到账: "บัญชีจริง",
  未设置资产密码: "ไม่ได้ตั้งรหัสผ่านเนื้อหา",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "เพื่อความปลอดภัยของทรัพย์สินของคุณ โปรดตั้งรหัสผ่านสินทรัพย์ก่อนทำการถอน",
  热榜: "ร้อน",
  涨幅榜: "ลุกขึ้น",
  跌幅榜: "ผู้แพ้",
  成交额榜: "การหมุนเวียน",
  关于我们: "เกี่ยวกับเรา",
  登录密码: "รหัสผ่านในการเข้าสู่ระบบ",
  设置: "ติดตั้ง",
  资产密码: "รหัสผ่านสินทรัพย์",
  修改登录密码: "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
  原密码: "รหัสผ่านเก่า",
  请输入新密码: "กรุณาใส่รหัสผ่านใหม่",
  请输入原密码: "กรุณากรอกรหัสผ่านเดิม",
  确认密码: "ยืนยันรหัสผ่าน",
  确定修改: "ตกลงเพื่อแก้ไข",
  修改资产密码: "แก้ไขรหัสผ่านเนื้อหา",
  验证码: "รหัสยืนยัน",
  资产密码使用提示: "เคล็ดลับในการใช้รหัสผ่านสินทรัพย์",
  "资产密码用于转移、提取资产和交易。":
    "รหัสผ่านสินทรัพย์ใช้ในการโอน ถอนสินทรัพย์ และซื้อขาย",
  "创建与登录密码不同的资产密码。":
    "สร้างรหัสผ่านสินทรัพย์ที่แตกต่างจากรหัสผ่านเข้าสู่ระบบ",
  "定期更改您的资产密码。": "เปลี่ยนรหัสผ่านเนื้อหาของคุณเป็นประจำ",
  提币历史: "ประวัติการถอนเงิน",
  "金额/余额": "จำนวนเงิน/ยอดคงเหลือ",
  "手续费/折扣": "ค่าธรรมเนียม/ส่วนลด",
  自选: "ไม่จำเป็น",
  现货: "สินค้าเฉพาะจุด",
  市价: "ราคาตลาด",
  止损设置: "หยุดการตั้งค่าการสูญเสีย",
  合约K线图: "แผนภูมิแท่งเทียนสัญญา",
  "24H量": "ปริมาณ 24H",
  "24H额": "จำนวน 24 ชม",
  合作指南: "คู่มือความร่วมมือ",
  盈亏计算: "การคำนวณกำไรขาดทุน",
  当前可用: "สามารถใช้งานได้",
  请输入加仓金额: "กรุณาใส่จำนวนเงินที่เพิ่มขึ้น",
  请重新输入加仓金额: "โปรดป้อนจำนวนเงินที่เพิ่มขึ้นอีกครั้ง",
  平仓数量: "ปริมาณการปิดบัญชี",
  欢迎登录: "กรุณาเข้าสู่ระบบ",
  "忘记密码?": "ลืมรหัสผ่าน?",
  "还没有账号？": "อย่ามีบัญชีหรือยัง?",
  立即注册: "สมัครเลย",
  繁體中文: "จีนดั้งเดิม",
  找回密码: "ดึงรหัสผ่าน",
  下一步: "ขั้นตอนต่อไป",
  注册账户: "ลงทะเบียนบัญชี",
  "请输入邀请码(选填)": "กรุณากรอกรหัสเชิญ (ไม่บังคับ)",
  谢邀豪礼: "ขอบคุณสำหรับคำเชิญ",
  "24小时邀请好友排名": "เชิญเพื่อนได้ตลอด 24 ชั่วโมง",
  "*人": "{0}ผู้คน",
  "差*人": "{0}คนจน",
  "已超过10万人，每月轻松赚钱": "มากกว่า 100,000 คน สร้างรายได้ง่ายๆทุกเดือน",
  最高: "สูงสุด",
  邀请链接: "เชิญลิงค์",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "แพลตฟอร์มแบ่งปันค่าธรรมเนียมการจัดการที่สร้างโดยเพื่อนบนแพลตฟอร์มกับคุณ (สปอต, สัญญา, เลเวอเรจ, แลกเปลี่ยนแฟลช)",
  平台和您一起分享手续费: "แพลตฟอร์มแบ่งปันค่าธรรมเนียมการจัดการกับคุณ",
  "*级": "{0}ระดับ",
  规则: "กฎ",
  我的好友: "เพื่อนที่ดีของฉัน",
  好友详情: "รายละเอียดเพื่อน",
  获得好友佣金方案: "รับโปรแกรม Friend Commission",
  我的等级: "เกรดของฉัน",
  我的邀请数据: "ข้อมูลคำเชิญของฉัน",
  当前等级: "ระดับปัจจุบัน",
  平台奖励您: "แพลตฟอร์มให้รางวัลแก่คุณ",
  最高可获取平台奖励: "รางวัลแพลตฟอร์มสูงสุดที่สามารถรับได้",
  邀请规则: "กฎการเชิญ",
  "邀请*级有效好友": "เชิญเพื่อนที่ถูกต้องระดับ {0}",
  好友等级: "ระดับเพื่อน",
  人: "ผู้คน",
  奖金派送: "การจัดส่งโบนัส",
  平台奖励: "รางวัลแพลตฟอร์ม",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "สิทธิ์ในการตีความขั้นสุดท้ายเป็นของแพลตฟอร์ม หากพบความผิดปกติในการรับรางวัลแพลตฟอร์ม รางวัลทั้งหมดจะถูกหักออกและบัญชีจะถูกระงับ การสูญเสียทรัพย์สินจะไม่ได้รับการกู้คืน",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "บัญชีของคุณต้องเป็นบัญชีที่ถูกต้อง และแพลตฟอร์มกำหนดว่าเงื่อนไขบัญชีที่ถูกต้องคือ (บัญชีเติมเงินในสกุลเงินใดก็ได้) มูลค่าขั้นต่ำ {0} USDT",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "เพื่อนที่คุณเชิญต้องเป็นผู้ใต้บังคับบัญชาที่ถูกต้อง และแพลตฟอร์มจะกำหนดว่าผู้ใต้บังคับบัญชาที่ถูกต้องคือมูลค่าขั้นต่ำ {0} USDT (การเติมเงินในบัญชีของสกุลเงินใดๆ)",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "บัญชีของผู้เชิญและผู้รับเชิญไม่สามารถเป็น IP เดียวกันได้",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "ระดับวีไอพีตัดสินจากจำนวนเพื่อนระดับ {0} ที่คุณเชิญ",
  佣金成分: "องค์ประกอบค่าคอมมิชชั่น",
  收益统计: "สถิติรายได้",
  昨日收益: "รายได้เมื่อวาน",
  月收益: "รายได้ต่อเดือน",
  获取收益: "รับรายได้",
  "总收益：": "รายได้รวม:",
  "*级好友": "{0} เพื่อนระดับ",
  理财购买: "การซื้อทางการเงิน",
  期限: "ระยะเวลา",
  可用金额: "จำนวนเงินที่มี",
  预估收益: "รายได้โดยประมาณ",
  申购上限: "ขีด จำกัด การสมัครสมาชิก",
  项目剩余: "รายการที่เหลืออยู่",
  "买入后预计*(SGT)开始计算收益。":
    "คาดว่า{0} (SGT) จะเริ่มคำนวณกำไรหลังจากซื้อ",
  计息日: "วันที่ดอกเบี้ย",
  申购日: "วันที่สมัครสมาชิก",
  到账日: "วันที่มาถึง",
  到期自动续投: "ต่ออายุอัตโนมัติเมื่อหมดอายุ",
  申购: "ซื้อ",
  搜索理财项目: "ค้นหาโครงการทางการเงิน",
  超高年化随心选: "รายปีสูงเป็นพิเศษ เลือกได้ตามต้องการ",
  "自由选择理财币种，稳定超额收益":
    "ทางเลือกฟรีของสกุลเงินในการบริหารความมั่งคั่ง ผลตอบแทนส่วนเกินที่มั่นคง",
  理财总资产: "สินทรัพย์การบริหารความมั่งคั่งโดยรวม",
  累计收益: "รายได้สะสม",
  申购数量: "ปริมาณการสมัครสมาชิก",
  立即购买: "ซื้อเลย",
  年化收益率: "อัตราผลตอบแทนต่อปี",
  理财订单: "คำสั่งทางการเงิน",
  持有: "ถือ",
  申购份额: "แบ่งปันการสมัครรับข้อมูล",
  到账日期: "วันที่มาถึง",
  申购成功: "สมัครสมาชิกสำเร็จ",
  到期: "วุฒิภาวะ",
  是否选择做多: "คุณเลือกที่จะทำอะไรมากกว่ากัน",
  "可用余额为0 不能操作": "ยอดเงินที่มีอยู่เป็น 0 และไม่สามารถดำเนินการได้",
  福利中心: "สถานสงเคราะห์",
  奖励记录: "บันทึกรางวัล",
  我获取到的奖励: "รางวัลที่ฉันได้รับ",
  总价值: "มูลค่ารวม",
  新手任务: "งานมือใหม่",
  身份认证: "การรับรองความถูกต้อง",
  身份验证: "การรับรองความถูกต้อง",
  去验证: "เพื่อตรวจสอบ",
  审核中: "ภายใต้การทบทวน",
  已验证: "ตรวจสอบแล้ว",
  认证失败: "รับรองความถูกต้องล้มเหลว",
  基础认证: "ใบรับรองพื้นฐาน",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "โปรดทราบว่าเมื่อตรวจสอบข้อมูลการรับรองความถูกต้องแล้ว จะไม่สามารถแก้ไขได้ ดังนั้นโปรดกรอกข้อมูลให้ถูกต้อง",
  "国家/地区": "ประเทศ/ภูมิภาค",
  请选择: "กรุณาเลือก",
  证件类型: "ประเภทของใบรับรอง",
  证件编码: "รหัสประจำตัวประชาชน",
  身份证: "บัตรประจำตัวประชาชน",
  护照: "หนังสือเดินทาง",
  驾驶证: "ใบอนุญาตขับรถ",
  请输入编码: "กรุณากรอกรหัส",
  名字: "ชื่อ",
  请输入: "กรุณาป้อน",
  中间名: "ชื่อกลาง",
  选填: "ไม่จำเป็น",
  姓氏: "นามสกุล",
  中国: "จีน",
  身份上传: "อัปโหลดข้อมูลประจำตัว",
  上传身份证: "รหัสอัปโหลด",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "เนื้อหาข้างต้นจำเป็นต้องอัปโหลดในรูปแบบ JPG/JPEG/PNG และตรวจสอบให้แน่ใจว่าภาพถ่ายมีความชัดเจน สมบูรณ์ และมีความสว่างสม่ำเสมอ และขนาดไม่เกิน {0}M.",
  确定提交: "ยืนยันการส่ง",
  去认证: "ไปที่การรับรองความถูกต้อง",
  挑战任务: "งานที่ท้าทาย",
  注册认证任务: "งานรับรองการลงทะเบียน",
  完成注册认证即可领取: "หลังจากเสร็จสิ้นการลงทะเบียนรับรอง คุณสามารถรับได้",
  领取奖励: "รับรางวัล",
  新人豪礼: "ของขวัญสำหรับผู้มาใหม่",
  "参与人数：": "จำนวนผู้เข้าร่วม:",
  条件: "สภาพ",
  入金量: "จำนวนเงินฝาก",
  完成: "เสร็จ",
  任务奖励: "รางวัลภารกิจ",
  距任务更新: "อัปเดตจากงาน",
  "条件：": "สภาพ:",
  活动规则: "กฎของกิจกรรม",
  奖励明细: "รายละเอียดรางวัล",
  已获得: "ได้รับ",
  交易奖励: "รางวัลการทำธุรกรรม",
  Win奖励: "รับรางวัล",
  已领取: "ได้รับ",
  亏损金额超过: "ยอดขาดทุนเกิน",
  单笔开仓金额超过: "เกินจำนวนเปิดตำแหน่งเดียว",
  交易量: "ปริมาณการซื้อขาย",
  待完成: "ที่จะเสร็จสมบูรณ์",
  入金: "เงินฝาก",
  盈利金额超过: "จำนวนกำไรเกิน",
  开仓金额: "ยอดเปิด",
  开仓金: "เงินฝากเริ่มต้น",
  盈利: "กำไร",
  亏损: "การสูญเสีย",
  领取: "รับ",
  未领取: "ไม่คุ้นเคย",
  待领取: "ที่จะรวบรวม",
  再交易: "ซื้อขายอีกครั้ง",
  即可获得: "สามารถรับได้",
  领取成功: "รับความสำเร็จ",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. กิจกรรมทั้งหมดจะนับตามเวลาสุดท้ายของกิจกรรม หากหมดเวลา รายได้จะถือว่าใช้ไม่ได้",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. รายได้ที่ได้รับจะกระจายไปยังบัญชีรางวัลของคุณ และคุณสามารถแลกเปลี่ยนและถอนเงินสดได้ตลอดเวลาตามความต้องการของคุณ",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. ประเภทของรางวัลที่ได้รับจะออกตามประเภทของงาน",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. สิทธิ์ในการตีความขั้นสุดท้ายเป็นของแพลตฟอร์ม หากพบวิธีการที่ผิดปกติในการเก็งกำไรโบนัสงานของแพลตฟอร์ม แพลตฟอร์มมีสิทธิ์ที่จะหยุดและล้างรายได้ที่คุณได้รับ",
  成长学院: "สถาบันการเจริญเติบโต",
  区块链: "บล็อกเชน",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "คำแนะนำแบบครบวงจรของคุณเกี่ยวกับ cryptocurrency เราจะพาคุณไปสู่ ​​cryptocurrency",
  "全仓合约定单的全部保证金。":
    "มาร์จิ้นเต็มสำหรับคำสั่งซื้อขายสัญญาข้ามมาร์จิ้น",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(ยอดบัญชี + (กำไรขาดทุนแบบลอยตัว - ค่าธรรมเนียมการจัดการ - ค่าธรรมเนียมข้ามคืน) = ทุน / มาร์จิ้นที่ใช้ไป * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    'กำไรและขาดทุนแบบลอยตัวจะส่งผลโดยตรงต่อ "มาร์จิ้นที่มี" เมื่อกำไรและขาดทุนที่ยังไม่เกิดขึ้นเพิ่มขึ้น มาร์จิ้นที่มีอยู่จะเพิ่มขึ้น และกำไรและขาดทุนที่ยังไม่เกิดขึ้นจริงจะลดลง และมาร์จิ้นที่มีอยู่จะลดลงด้วย',
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "ยอดคงเหลือในบัญชี - (มาร์จิ้นที่ใช้แล้ว) + (กำไรขาดทุนแบบลอยตัว - ค่าธรรมเนียมการจัดการ - ค่าธรรมเนียมข้ามคืน)",
  "注:可继续用于开仓的保证金。":
    "หมายเหตุ: มาร์จิ้นที่สามารถใช้เปิดตำแหน่งต่อไปได้",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "ยอดบัญชี + (กำไรขาดทุนลอยตัว - ค่าธรรมเนียมการจัดการ - ค่าธรรมเนียมข้ามคืน)",
  "注:当前的资金结余。": "หมายเหตุ: ยอดเงินปัจจุบัน",
  "指的是合约账户的全部余额，包含不可用余额。":
    "หมายถึงยอดคงเหลือทั้งหมดของบัญชีสัญญา รวมถึงยอดคงเหลือที่ไม่พร้อมใช้งาน",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "หมายเหตุ: ยิ่งอัตราความเสี่ยงสูง ความเสี่ยงยิ่งต่ำ และยิ่งอัตราความเสี่ยงต่ำ ความเสี่ยงยิ่งสูงขึ้น",
  该功能尚未开发: "คุณลักษณะนี้ยังไม่ได้รับการพัฒนา",
  重置密码: "รีเซ็ตรหัสผ่าน",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "กรุณาใส่ตัวอักษร 8-20 ตัว ต้องมีตัวอักษร ตัวเลข และอักขระพิเศษ",
  修改成功: "แก้ไขเรียบร้อยแล้ว",
  输入验证码: "ใส่รหัสยืนยัน",
  输入密码: "ใส่รหัสผ่าน",
  详情说明: "รายละเอียด",
  已售罄: "ขายหมดแล้ว",
  剩余期限: "ระยะเวลาที่เหลือ",
  限期: "วันกำหนดส่ง",
  闪兑货币选择: "การเลือกสกุลเงินทันที",
  地区选择: "การเลือกภูมิภาค",
  "搜索国家/地区": "ค้นหาประเทศ",
  "身份信息已提交，将在*小时内审核完成":
    "ส่งข้อมูลระบุตัวตนแล้วและจะได้รับการตรวจสอบภายใน {0} ชั่วโมง",
  "选择国家/地区": "เลือกประเทศ",
  "止盈价格需高于*": "ราคาทำกำไรต้องสูงกว่า {0}",
  "止损价格需低于*": "ราคาหยุดการขาดทุนจะต้องต่ำกว่า {0}",
  "止盈价格需低于*": "ราคา Take Profit ต้องต่ำกว่า {0}",
  "止损价格需高于*": "ราคาหยุดการขาดทุนจะต้องสูงกว่า {0}",
  教程详情: "รายละเอียดการสอน",
  请输入止损价: "กรุณาใส่ราคาหยุด",
  活期: "หมุนเวียน",
  赎回后立即到账: "ทันทีหลังจากไถ่ถอน",
  赎回: "การไถ่ถอน",
  赎回理财: "แลกการจัดการทางการเงิน",
  是否赎回当前的理财订单: "ไม่ว่าจะแลกคำสั่งบริหารความมั่งคั่งปัจจุบันหรือไม่",
  维护: "บำรุงรักษา",
  "系统正在维护中……": "อยู่ระหว่างปรับปรุงระบบ...",
  合约: "สัญญา",
  闪电兑换: "การแลกเปลี่ยนสายฟ้า",
  流水挖矿: "การขุดแบบไหล",
  邀请豪礼: "ของขวัญเชิญ",
  计算器: "เครื่องคิดเลข",
  最新价: "ราคาล่าสุด",
  涨跌幅: "เปลี่ยน",
  关注币种添加自选: "ติดตามสกุลเงินและเพิ่มตัวเลือก",
  一键添加自选: "คลิกเดียวเพิ่มตัวเลือก",
  全标已读: "อ่านแท็กทั้งหมดแล้ว",
  无消息: "ไม่มีข่าว",
  "暂时还没有收到任何消息通知哦!": "ยังไม่ได้รับการแจ้งเตือนใดๆ!",
  没有更多数据: "ไม่มีข้อมูลเพิ่มเติม",
  闪兑: "แฟลช",
  从: "จาก",
  "可用余额：": "ยอดเงินคงเหลือ:",
  至: "ถึง",
  预览兑换结果: "ดูตัวอย่างผลการแลกเปลี่ยน",
  闪兑规则: "กฎการแลกเปลี่ยนแฟลช",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "ตลาดแลกเปลี่ยนแฟลชอาจมีการเปลี่ยนแปลง โปรดดูจำนวนเงินจริงที่ได้รับ",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "อัตราแลกเปลี่ยนกำหนดโดยบุคคลที่สาม เนื่องจากต้นทุนการแลกเปลี่ยนและความผันผวนของตลาด อัตราแลกเปลี่ยนที่คุณแลกเปลี่ยนอาจสูงกว่าอัตราแลกเปลี่ยนในตลาด โปรดยืนยันอย่างรอบคอบก่อนดำเนินการต่อ",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "แพลตฟอร์มนี้เรียกเก็บค่าธรรมเนียมการจัดการประมาณ {fee}% สำหรับการโอนเงินแต่ละครั้ง ซึ่งใช้เพื่อชำระค่าใช้จ่ายในการแลกเปลี่ยนในการแลกเปลี่ยน",
  确认汇兑: "ยืนยันการแลกเปลี่ยน",
  您预估得到: "คุณประมาณการ",
  汇兑: "แลกเปลี่ยน",
  汇兑比例: "อัตราแลกเปลี่ยน",
  刷新: "เพื่อรีเฟรช",
  兑换: "แลกเปลี่ยน",
  没有更多了: "ไม่มีอีกแล้ว",
  搜索币种: "ค้นหาสกุลเงิน",
  可用: "มีอยู่",
  我知道了: "เข้าใจแล้ว",
  最新价格: "ราคาล่าสุด",
  确认: "ยืนยัน",
  最大: "ขีดสุด",
  "风险率(%)": "อัตราความเสี่ยง (%)",
  持仓: "ตำแหน่ง",
  当前委托: "ค่าคอมมิชชั่นปัจจุบัน",
  合作交易历史记录: "ประวัติการทำธุรกรรมความร่วมมือ",
  重置: "รีเซ็ต",
  余额: "สมดุล",
  现货账户: "บัญชีเงินทุน",
  合约账户: "ฟิวเจอร์ส",
  WIN账户: "ชนะ",
  赏金账户: "ของขวัญ",
  总资产折合: "สินทรัพย์รวมเทียบเท่า",
  今日收益: "รายได้วันนี้",
  充币: "เงินฝาก",
  提币: "ถอนเหรียญ",
  账户权益: "ส่วนของบัญชี",
  "数量/类别": "จำนวน/ประเภท",
  全部币种: "ทุกสกุลเงิน",
  全部类型: "ทุกประเภท",
  账单信息: "ข้อมูลการเรียกเก็บเงิน",
  理财赎回: "การไถ่ถอนทางการเงิน",
  购买理财: "ซื้อเงิน",
  收入: "รายได้",
  支出: "รายจ่าย",
  到: "มาถึง",
  资产划转: "การโอนทรัพย์สิน",
  "最少*": "น้อยที่สุด*",
  "可用资产：": "สินทรัพย์ที่มีอยู่:",
  确认划转: "ยืนยันการโอน",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "เฉพาะเมื่อสินทรัพย์ถูกโอนไปยังบัญชีที่เกี่ยวข้องเท่านั้นที่สามารถทำธุรกรรมได้ และไม่มีค่าธรรมเนียมการจัดการสำหรับการโอนระหว่างบัญชี",
  币种账户选择: "การเลือกบัญชีสกุลเงิน",
  选择账户: "เลือกบัญชี",
  划转详情: "รายละเอียดการโอน",
  划转明细: "รายละเอียดการโอน",
  收入账单: "ใบแจ้งรายได้",
  支出账单: "ใบเบิกค่าใช้จ่าย",
  金额: "จำนวนเงิน",
  总收益: "รายได้รวม",
  佣金: "คณะกรรมการ",
  用户名: "ชื่อผู้ใช้",
  "已领取：": "ได้รับ:",
  "未领取：": "ไม่คุ้นเคย:",
  "请选择国家/地区": "กรุณาเลือกประเทศ",
  请上传身份信息: "โปรดอัปโหลดข้อมูลระบุตัวตน",
  请选择证件类型: "กรุณาเลือกประเภทเอกสาร",
  请填写证件编码: "กรุณากรอกเลขประจำตัวประชาชน",
  请填写名字: "กรุณากรอกชื่อ",
  请填写姓氏: "กรุณากรอกนามสกุล",
  单向持仓: "ตำแหน่งทางเดียว",
  投资金额: "จำนวนเงินลงทุน",
  天: "ท้องฟ้า",
  请输入手机号: "กรุณากรอกหมายเลขโทรศัพท์",
  搜索: "ค้นหา",
  搜索历史: "ประวัติการค้นหา",
  热门推荐: "คำแนะนำยอดนิยม",
  "《Xspace Earn协议》": "《 Xspace รับข้อตกลง》",
  我已了解并同意: "ฉันเข้าใจและตกลง",
  协议: "มาตรการ",
  Xspace官方中文交流群: "Xspace กลุ่มสื่อสารภาษาจีนอย่างเป็นทางการ",
  Xspace官方英文交流群: "Xspace กลุ่มสื่อสารภาษาอังกฤษอย่างเป็นทางการ",
  预计维护至: "การบำรุงรักษาที่คาดว่าจะ",
  更多功能: "คุณสมบัติเพิ่มเติม",
  下载APP: "ดาวน์โหลดแอป",
  理财: "การจัดการทางการเงิน",
  推荐: "แนะนำ",
  Telegram官方中文频道: "ช่องทางการของ Telegram ภาษาจีน",
  Telegram官方英文频道: "Telegram ช่องภาษาอังกฤษอย่างเป็นทางการ",
  官方邮箱: "อีเมลอย่างเป็นทางการ",
  客服邮箱: "อีเมลฝ่ายบริการลูกค้า",
  上述信息最终解释权归官方所有:
    "การตีความขั้นสุดท้ายของข้อมูลข้างต้นเป็นของทางการ",
  IOS版下载: "ดาวน์โหลดเวอร์ชัน iOS",
  Android版下载: "ดาวน์โหลดสำหรับ Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "ค่าธรรมเนียมการจัดการ = ค่าธรรมเนียมการจัดการการซื้อ + อัตราเงินทุน + ค่าธรรมเนียมการจัดการการขาย",
  资金划转: "การโอนเงิน",
  止盈: "ขายทำกำไร",
  止损: "หยุดการสูญเสีย",
  自动平仓: "ปิดอัตโนมัติ",
  委托挂单: "มอบหมายคำสั่งซื้อที่รอดำเนินการ",
  买: "ซื้อ",
  卖: "ขาย",
  "买入/做多": "ซื้อ/ยาว",
  "卖出/做空": "ขาย/ชอร์ต",
  详情: "รายละเอียด",
  浮动涨跌: "ลอยขึ้นและลง",
  最小: "ที่เล็กที่สุด",
  充币数量: "จำนวนเงินฝาก",
  请输入充币数量: "กรุณากรอกจำนวนเงินฝาก",
  支付截图: "ภาพหน้าจอการชำระเงิน",
  提交: "ส่ง",
  上传驾驶证: "อัปโหลดใบขับขี่",
  上传护照: "อัปโหลดหนังสือเดินทาง",
  加载中: "กำลังโหลด",
  上传成功: "อัปโหลดสำเร็จ",
  充值历史: "ประวัติการเติมเงิน",
  合约卖出手续费: "ค่าขายสัญญา",
  合约买入手续费: "ค่าซื้อสัญญา",
  系统加款: "ระบบเติมเงิน",
  系统减款: "ระบบหักเงิน",
  合约资金费率: "อัตราเงินทุนตามสัญญา",
  佣金分成: "ส่วนแบ่งค่าคอมมิชชั่น",
  U本位合约: "U สัญญามาตรฐาน",
  资产管理: "การจัดการสินทรัพย์",
  APP下载: "ดาวน์โหลดแอป",
  全球领先的数字理财平台: "แพลตฟอร์มการจัดการความมั่งคั่งดิจิทัลชั้นนำของโลก",
  "即刻交易比特币、以太坊等上百种数字资产":
    "แลกเปลี่ยนสินทรัพย์ดิจิทัลหลายร้อยรายการทันที เช่น Bitcoin และ Ethereum",
  "24H涨跌幅": "24H เพิ่มขึ้นและลดลง",
  查看更多行情: "ดูใบเสนอราคาเพิ่มเติม",
  近24小时成交量: "ปริมาณการซื้อขายใน 24 ชั่วโมงที่ผ่านมา",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "จัดหาคู่สกุลเงินและสัญญาการซื้อขายหลายร้อยรายการเพื่อตอบสนองความต้องการในการซื้อขายที่หลากหลาย แพลตฟอร์มนี้มีผู้ใช้มากกว่า 20 ล้านคนใน 200 ประเทศและภูมิภาค และเป็นแพลตฟอร์มบริการสินทรัพย์ดิจิทัลชั้นนำของโลก",
  用户国家分布: "การกระจายประเทศของผู้ใช้",
  用户数: "หมายเลขผู้ใช้",
  交易对: "คู่ซื้อขาย",
  服务支持: "บริการสนับสนุน",
  "随时随地，多平台终端交易": "ทุกที่ทุกเวลาธุรกรรมเทอร์มินัลหลายแพลตฟอร์ม",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "เข้ากันได้อย่างสมบูรณ์แบบกับเทอร์มินัลหลายเครื่อง และสามารถตอบสนองความต้องการในการทำธุรกรรมในสถานการณ์ต่างๆ ได้ตลอดเวลา",
  随时查看实时行情: "ดูตลาดแบบเรียลไทม์ได้ตลอดเวลา",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "ซื้อและขาย BTC, ETH, DOGE และสินทรัพย์ดิจิทัลอื่น ๆ ได้อย่างง่ายดาย",
  获取您关注的加密货币价格变化预警:
    "รับการแจ้งเตือนเกี่ยวกับการเปลี่ยนแปลงราคาในสกุลเงินดิจิทัลที่คุณสนใจ",
  "查看比特币现货、期货、期权价格": "ดู bitcoin สปอต ฟิวเจอร์ส ราคาออปชั่น",
  比较各交易所加密货币价格: "เปรียบเทียบราคา cryptocurrency ในการแลกเปลี่ยน",
  开启您的数字货币之旅: "เริ่มต้นเส้นทางสกุลเงินดิจิทัลของคุณ",
  快捷购买数字货币: "ซื้อสกุลเงินดิจิทัลอย่างรวดเร็ว",
  "使用多种支付方式交易数字货币，安全快捷":
    "ใช้วิธีการชำระเงินหลายวิธีเพื่อแลกเปลี่ยนสกุลเงินดิจิทัล ปลอดภัยและรวดเร็ว",
  最优的交易费率: "อัตราค่าธรรมเนียมการทำธุรกรรมที่เหมาะสมที่สุด",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "อัตราการทำธุรกรรมพิเศษ สิทธิ์ VIP ที่แข่งขันได้ และเพลิดเพลินกับบริการคุณภาพดีที่สุด",
  可信赖的安全保障: "ความปลอดภัยที่เชื่อถือได้",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "มาตรการรักษาความปลอดภัยที่ซับซ้อนของเราและกองทุน SAFU ปกป้องสินทรัพย์ดิจิทัลของคุณจากความเสี่ยงทั้งหมด",
  交易: "ซื้อขาย",
  币币市场: "ตลาดสกุลเงิน",
  "24H成交量": "ปริมาณการซื้อขาย 24 ชั่วโมง",
  交易所: "แลกเปลี่ยน",
  "24H最高": "สูงสุด 24 ชม",
  "24H最低": "ขั้นต่ำ 24 ชม",
  永续合约: "สัญญาถาวร",
  日涨跌: "เพิ่มขึ้นและลดลงทุกวัน",
  交易深度: "ความลึกของธุรกรรม",
  "资产(合约)": "สินทรัพย์ (สัญญา)",
  历史仓位: "ตำแหน่งทางประวัติศาสตร์",
  兑换记录: "บันทึกการแลกเปลี่ยน",
  类型: "พิมพ์",
  充值记录: "บันทึกการเติมเงิน",
  划转记录: "บันทึกการโอน",
  类别: "หมวดหมู่",
  历史账单: "บิลประวัติศาสตร์",
  在线充值: "เติมเงินออนไลน์",
  安全设置: "ตั้งค่าความปลอดภัย",
  用于账户登录使用: "สำหรับการเข้าสู่ระบบบัญชีใช้",
  用户提现时安全验证使用: "ใช้สำหรับตรวจสอบความปลอดภัยเมื่อผู้ใช้ถอนเงินสด",
  验证: "ตรวจสอบ",
  万: "หมื่น",
  随时随地开启交易: "เปิดธุรกรรมทุกที่ทุกเวลา",
  "*货币交易所的所有功能尽在你的手中。":
    "{0} ฟังก์ชั่นทั้งหมดของการแลกเปลี่ยนสกุลเงินอยู่ในมือของคุณ",
  "下载*货币交易所APP。": "ดาวน์โหลด {0}แอปแลกเปลี่ยนสกุลเงิน",
  下载自: "ดาวน์โหลดจาก",
  内测版: "รุ่นเบต้า",
  下载: "ดาวน์โหลด",
  扫码下载: "สแกนโค้ดเพื่อดาวน์โหลด",
  设置您的资产密码: "ตั้งรหัสผ่านเนื้อหาของคุณ",
  法币: "สกุลเงินฝรั่งเศส",
  我要买: "ฉันต้องการที่จะซื้อ",
  我要卖: "ฉันต้องการขาย",
  请输入金额: "กรุณากรอกจำนวนเงิน",
  汇率: "อัตราแลกเปลี่ยน",
  获得: "รับ",
  支付通道: "ช่องทางการชำระเงิน",
  收款通道: "ช่องทางการชำระเงิน",
  "出售过程需要务必确认好您的收款方式为本人。":
    "ในระหว่างขั้นตอนการขาย จำเป็นต้องยืนยันว่าวิธีการชำระเงินเป็นของคุณเอง",
  当前法币暂不支持交易对可尝试前往提现:
    "สกุลเงินตามกฎหมายปัจจุบันไม่รองรับคู่การซื้อขาย คุณสามารถลองถอนออกได้",
  前往提现: "ไปที่เงินสด",
  该法币暂无通道: "ไม่มีช่องสำหรับสกุลเงินคำสั่งนี้",
  "正在出售中，请耐心等待": "สำหรับการขายโปรดอดใจรอ",
  请选择支付通道: "กรุณาเลือกช่องทางการชำระเงิน",
  请选择方式: "กรุณาเลือกวิธีการ",
  法币历史: "ประวัติเฟียต",
  买币: "ซื้อเหรียญ",
  卖币: "ขายเหรียญ",
  失败: "ล้มเหลว",
  已完成: "สมบูรณ์",
  未付款: "ค้างชำระ",
  待审核: "ที่จะได้รับการตรวจสอบ",
  打款中: "การจ่ายเงิน",
  订单详情: "รายละเอียดการสั่งซื้อ",
  联系客服: "ติดต่อฝ่ายบริการลูกค้า",
  到账金额: "จำนวนเงินที่ได้รับ",
  通道: "ทางเดิน",
  收款人: "ผู้รับเงิน",
  收款账户: "ลูกหนี้การค้า",
  "订单出售失败，请查下方失败原因":
    "การขายคำสั่งซื้อล้มเหลว โปรดตรวจสอบสาเหตุของความล้มเหลวด้านล่าง",
  失败原因: "เหตุผลความล้มเหลว",
  您还未进行付款: "คุณยังไม่ได้ชำระเงิน",
  您已成功购买: "คุณซื้อสำเร็จแล้ว",
  已取消订单: "คำสั่งซื้อถูกยกเลิก",
  "订单正在审核中，请耐心等待": "คำสั่งซื้ออยู่ระหว่างการตรวจสอบ โปรดอดใจรอ",
  您已成功出售: "คุณขายสำเร็จแล้ว",
  "订单正在打款中，请耐心等待": "คำสั่งซื้ออยู่ระหว่างการชำระเงิน โปรดอดทนรอ",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "ขั้นตอนการชำระเงิน คุณจะต้องไปที่แพลตฟอร์มอื่นเพื่อทำการสั่งจ่าย โปรดให้ความสำคัญกับความปลอดภัยของข้อมูล",
  当前法币暂不支持交易对可尝试前往充值:
    "สกุลเงินตามกฎหมายปัจจุบันไม่รองรับคู่การซื้อขาย คุณสามารถลองเติมเงินได้",
  前往充值: "ไปเติมเงิน",
  购买: "ซื้อ",
  订单号: "หมายเลขคำสั่งซื้อ",
  单价: "ราคาต่อหน่วย",
  到账数量: "จำนวนเงินที่มาถึง",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "ขณะนี้มีคำสั่งซื้อที่ค้างชำระ คุณต้องการเริ่มต้นคำสั่งชำระเงินใหม่ต่อไปหรือไม่",
  继续支付: "ชำระเงินต่อไป",
  重新下单: "สั่งซื้อใหม่",
  是否确定出售: "แน่ใจนะว่าจะขาย",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "หลังจากยืนยันการขายแล้ว แพลตฟอร์มจะถูกกำหนดให้กับผู้ซื้อ โปรดรออย่างอดทนเพื่อให้แพลตฟอร์มตรงกัน",
  出售: "ขาย",
  收款方式: "วิธีการชำระเงิน",
  订单已生成: "คำสั่งซื้อที่สร้างขึ้น",
  取消订单: "ยกเลิกคำสั่งซื้อ",
  请在: "กรุณาที่",
  内完成付款: "ชำระเงินให้เสร็จสิ้นภายใน",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注":
    "ออกจากแพลตฟอร์ม เข้าสู่ระบบการชำระเงินที่คุณระบุ โอนไปยังบัญชีต่อไปนี้ของผู้ขาย และอย่าลืมบันทึกในการชำระเงิน",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "หากไม่มีหมายเหตุใดๆ ในระหว่างการชำระเงิน ผู้ขายจะไม่สามารถยืนยันการรับเงินได้ ส่งผลให้สูญเสียทรัพย์สินที่ไม่สามารถกู้คืนได้",
  "未在规定的时间内付款，订单都将被取消。":
    "หากไม่ชำระเงินภายในเวลาที่กำหนด คำสั่งซื้อจะถูกยกเลิก",
  姓名: "ชื่อ",
  收款姓名: "ชื่อผู้รับ",
  开户支行: "สาขาที่เปิดบัญชี",
  银行卡号: "หมายเลขบัตรธนาคาร",
  "付款后，返回本平台": "หลังจากชำระเงินแล้ว ให้กลับมาที่แพลตฟอร์มนี้",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    'อย่าลืมคลิกปุ่ม "ฉันชำระเงินเรียบร้อยแล้ว แจ้งผู้ขาย" ด้านล่าง',
  未点击卖家不会放款: "ผู้ขายจะไม่ปล่อยเงินโดยไม่คลิก",
  交易条款: "เงื่อนไขการทำธุรกรรม",
  "购买资金来源，必须合法安全的资金，方可交易":
    "แหล่งเงินทุนในการซื้อจะต้องเป็นเงินทุนที่ถูกกฎหมายและปลอดภัยก่อนทำการซื้อขาย",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "ไม่อนุญาตให้มีการฉ้อโกง แผนพีระมิด การพนัน หรือการทำธุรกรรมทางการเงินที่ผิดกฎหมายอื่นๆ",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "หลังจากการทำธุรกรรมเสร็จสิ้น หากมีความเสี่ยงของเงินทุน เงินทุนที่ถูกระงับหรือสงสัยว่ามีการฉ้อโกง แผนการแบบพีระมิด หรือการพนัน เราจะไม่ปล่อย U ให้กับผู้ซื้ออีกต่อไปและจะคืนเงินให้",
  "已付款，通知卖家": "ชำระเงินแล้ว แจ้งผู้ขาย",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "หากผู้ซื้อยกเลิกคำสั่งซื้อทั้งหมด {0} ในวันเดียวกัน ฟังก์ชันการซื้อในวันนั้นจะถูกยกเลิก คุณแน่ใจหรือที่จะยกเลิกคำสั่งซื้อนี้",
  添加收款方式: "เพิ่มวิธีการชำระเงิน",
  是否删除此收款方式: "ว่าจะลบวิธีการชำระเงินนี้หรือไม่",
  删除: "ลบ",
  请选择法币: "กรุณาเลือกสกุลเงินคำสั่ง",
  机构名称: "ชื่อสถาบัน",
  请选择机构: "กรุณาเลือกสถาบันการศึกษา",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "เมื่อคุณขายสกุลเงินดิจิทัล วิธีการชำระเงินที่คุณเลือกจะแสดงต่อผู้ซื้อ โปรดยืนยันว่าถูกต้อง",
  请选择银行: "กรุณาเลือกธนาคาร",
  请输入姓名: "กรุณาพิมพ์ชื่อของคุณ",
  账号: "บัญชีผู้ใช้",
  请输入账号: "กรุณากรอกบัญชี",
  收款码: "รหัสใบเสร็จ",
  "银行账号/卡号": "หมายเลขบัญชีธนาคาร / หมายเลขบัตร",
  "请输入银行账号/卡号": "กรุณากรอกบัญชีธนาคาร/หมายเลขบัตร",
  "开户支行（选填）": "สาขาที่เปิดบัญชี (ไม่บังคับ)",
  请输入开户支行: "กรุณากรอกสาขาที่เปิดบัญชี",
  "加入*官方频道": "เข้าร่วม {0}ช่องทางการ",
  关于: "เกี่ยวกับ",
  条款: "ข้อกำหนด",
  其他: "อื่นๆ",
  成功: "ความสำเร็จ",
  等待: "รอ",
  作废: "เป็นโมฆะ",
  确认付款: "ยืนยันการชำระเงิน",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "ชำระเงินเรียบร้อยแล้ว? หากการชำระเงินได้รับการยืนยัน ร้านค้าจะยืนยันว่าได้รับการชำระเงินภายใน {0} นาที",
  最大金额: "จำนวนเงินสูงสุด",
  最小金额: "จำนวนเงินขั้นต่ำ",
  付款: "การชำระเงิน",
  法币充值: "เติมสกุลเงิน Fiat",
  法币提现: "การถอนสกุลเงิน Fiat",
  待支付: "ที่จะต้องจ่าย",
  已支付: "จ่าย",
  商户名: "ชื่อผู้ค้า",
  当前没有添加支付方式: "ขณะนี้ยังไม่มีการเพิ่มวิธีการชำระเงิน",
  添加后再出售: "เพิ่มเพื่อขาย",
  新人大礼包: "ความสนุกสนานของผู้มาใหม่",
  注册即可领取: "ลงทะเบียนเพื่อรับ",
  立即领取: "รับทันที",
  不再提示: "อย่าเตือนอีกเลย",
  "该奖励需在APP中领取，请下载APP": "ต้องรับรางวัลในแอป โปรดดาวน์โหลดแอป",
  去交易: "กับการค้า",
  期权交易: "การซื้อขายตัวเลือก",
  交易额: "จำนวนการทำธุรกรรม",
  可用额度: "จำนวนที่มีอยู่",
  交易周期: "รอบการทำธุรกรรม",
  看涨: "รั้น",
  看跌: "งุ่มง่าม",
  当前持有: "จัดขึ้นในปัจจุบัน",
  胜率: "เปอร์เซ็นต์การชนะ",
  "盈利/亏损数": "กำไร/ขาดทุน",
  累计实现盈亏: "กำไรขาดทุนที่รับรู้สะสม",
  秒: "ที่สอง",
  分: "นาที",
  小时: "ชั่วโมง",
  天: "ท้องฟ้า",
  周: "สัปดาห์",
  下单时间: "เวลาสั่งซื้อ",
  剩余时间: "เวลาที่เหลือ",
  买入价: "ราคาซื้อ",
  结算价: "ราคาชำระ",
  实现盈利: "ได้กำไร",
  结算时间: "เวลาชำระบัญชี",
  期权: "ตัวเลือก",
  新手教程: "บทช่วยสอนสำหรับผู้เริ่มต้น",
  我的订单: "คำสั่งของฉัน",
  赔率: "อัตราต่อรอง",
  全部订单: "ทุกออเดอร์",
  持有订单: "ระงับการสั่งซื้อ",
  历史订单: "คำสั่งทางประวัติศาสตร์",
  输入交易额度: "ป้อนจำนวนเงินที่ทำธุรกรรม",
  选择交易周期: "เลือกวงจรการซื้อขาย",
  去注册: "เพื่อลงทะเบียน",
  冻结: "แช่แข็ง",
  期权支出: "ตัวเลือกการจ่ายเงิน",
  期权收入: "รายได้เสริม",
  用户提现: "การถอนผู้ใช้",
  "是否购买？": "คุณต้องการซื้อหรือไม่?",
  购买成功: "ซื้อสำเร็จ",
  请签名: "กรุณาลงชื่อ",
  提交签名: "ส่งลายเซ็น",
  清空签名: "ลายเซ็นที่ชัดเจน",
  签名审核中: "ตรวจสอบลายเซ็น",
  已提交: "ส่ง",
  扫一扫下载APP: "สแกนเพื่อดาวน์โหลด APP",
  新手领取大礼包: "สามเณรได้รับความสนุกสนาน",
  注册实名即送彩金: "ลงทะเบียนชื่อจริงและรับโบนัส",
  交易总额: "จำนวนธุรกรรมทั้งหมด",
  资产不足: "ทรัพย์สินไม่เพียงพอ",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "บัญชี Win มีสินทรัพย์ไม่เพียงพอและสามารถโอนจากบัญชีเงินทุนไปยังบัญชีนี้ได้",
  Win: "ชนะ",
  在线充值: "เติมเงินออนไลน์",
  比赛: "ประกวด",
  未开始: "ยังไม่ได้เริ่มต้น",
  赛程: "กำหนดการ",
  赛果: "ผลลัพธ์",
  已结束: "เกิน",
  让球: "แฮนดิแคป",
  进球数: "เป้าหมาย",
  大: "ใหญ่",
  小: "เล็ก",
  胜负平: "ผูก",
  和局: "ผูก",
  投注: "การเดิมพัน",
  下注金额: "จำนวนเงินเดิมพัน",
  下注: "วางเดิมพัน",
  阵容: "เข้าแถว",
  分析: "วิเคราะห์",
  输入下注金额: "ใส่จำนวนเงินเดิมพัน",
  下注成功: "เดิมพันสำเร็จ",
  投注记录: "บันทึกการเดิมพัน",
  未结算: "ความไม่สงบ",
  已结算: "ตัดสิน",
  流水: "น้ำไหล",
  输赢: "ชนะหรือแพ้",
  赛时: "เวลาเล่นเกม",
  下注时间: "เวลาเดิมพัน",
  足彩竞猜: "การพนันฟุตบอล",
  查看详情: "ตรวจสอบรายละเอียด",
  输: "แพ้",
  赢: "ชนะ",
  主: "เจ้าภาพ",
  客: "แขก",
  主胜: "ชนะหลัก",
  客胜: "แขกรับเชิญ",
  平: "แบน",
  已延期: "เลื่อนออกไป",
  账号异常: "บัญชีที่ผิดปกติ",
  全场独赢: "ผู้ชนะ",
  全场让球: "แต้มต่อ",
  全场大小: "ขนาดเต็ม",
  总进球: "เป้าหมายทั้งหมด",
  拍摄照片要求: "ข้อกำหนดในการถ่ายภาพ",
  标准拍摄: "ยิงมาตรฐาน",
  边框缺失: "ขาดขอบ",
  照片模糊: "ภาพเบลอ",
  闪光强烈: "แฟลชที่แข็งแกร่ง",
  上传手持证件照: "อัปโหลดภาพถ่ายหนังสือเดินทาง",
  上传证件照: "อัปโหลดรูปถ่ายประจำตัว",
  换一张: "เปลี่ยนอย่างใดอย่างหนึ่ง",
  出生日期: "วันเกิด",
  请选择出生日期: "กรุณาเลือกวันเดือนปีเกิด",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "หลังจากป้อนการยืนยันด้วยกราฟิกที่ถูกต้องด้านล่าง ให้รับรหัสยืนยันทางอีเมลเพื่อลงทะเบียน",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "คุณยังมีเวลา {0} การตรวจสอบสิทธิ์เหลืออยู่ ซึ่งเกินจำนวนครั้งที่คุณจะไม่สามารถดำเนินการตรวจสอบสิทธิ์ต่อได้",
  上半场: "ครึ่งแรก",
  下半场: "ครึ่งหลัง",
  独赢: "ชนะคนเดียว",
  上半场独赢: "ชนะครึ่งแรก",
  下半场独赢: "ชนะครึ่งหลัง",
  上半场让球: "แฮนดิแคปครึ่งแรก",
  下半场让球: "แฮนดิแคปครึ่งหลัง",
  上半场大小球: "ประตูในครึ่งแรก",
  下半场大小球: "ประตูครึ่งหลัง",
  波胆: "คอเลสเตอรอล",
  上半场波胆: "สกอร์ครึ่งแรก",
  下半场波胆: "สกอร์ครึ่งหลัง",
  单双: "เดี่ยวและคู่",
  上半场单双: "อัตราต่อรองและสองเท่าในครึ่งแรก",
  下半场单双: "อัตราต่อรองและสองเท่าในครึ่งหลัง",
  总进球: "เป้าหมายทั้งหมด",
  上半场总进球: "ประตูรวมในครึ่งแรก",
  下半场总进球: "ประตูรวมครึ่งหลัง",
  单: "หนึ่ง",
  双: "คู่",
  中场: "กองกลาง",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "หมายเหตุ: โปรดทำตามภาพตัวอย่างนี้เพื่อเขียนข้อความบนกระดาษขาวและถ่ายรูปพร้อมบัตรประจำตัวของคุณ",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "เมื่อเร็วๆ นี้ มีการค้นพบบัญชีที่โกงจำนวนมาก และบัญชีที่ผิดกฎหมายจำนวนมากถูกลงโทษ หากบัญชีใดถูกตัดสินว่าผิดว่าเป็นบัญชีที่ผิดกฎหมาย โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์",
  最小下注金额: "จำนวนเงินเดิมพันขั้นต่ำ",
  参与活动最小下注金额: "จำนวนเงินเดิมพันขั้นต่ำในการเข้าร่วมกิจกรรม",
  记住密码: "จดจำรหัสผ่าน",
  比分: "คะแนน",
  "您还未登录，请先登录": "คุณยังไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบก่อน",
  立即登录: "เข้าสู่ระบบทันที",
  下注限额: "วงเงินเดิมพัน",
  可赢金额: "จำนวนเงินที่สามารถชนะได้",
  闪兑详情: "รายละเอียดแฟลช",
  大小球: "ลูกขนาด",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "เนื่องจากอัตราแลกเปลี่ยน อาจมีความแตกต่างระหว่างจำนวนเงินเดิมพันและจำนวนเงินเดิมพันจริง โปรดดูที่คำสั่งซื้อ",
  开赛时间: "เวลาเริ่มต้น",
  足球收入: "รายได้ฟุตบอล",
  足球支出: "การใช้จ่ายฟุตบอล",
  活动详情: "รายละเอียดกิจกรรม",
  为世界杯喝彩: "เชียร์ฟุตบอลโลก",
  我的竞猜: "ฉันเดา",
  "竞猜比赛、有机会瓜分*USDT": "เดาเกมและมีโอกาสแบ่งปัน {0}USDT",
  "瓜分*USDT": "หาร {0}USDT",
  距离活动结束还有: "ยังมีเวลาจนจบงาน",
  我的门票: "ตั๋วของฉัน",
  竞猜结束时间: "เดาเวลาสิ้นสุด",
  猜比分: "เดาคะแนน",
  "福利派送中，完成任务即可获取门票":
    "กำลังดำเนินการแจกจ่ายสวัสดิการ ทำภารกิจให้เสร็จสิ้นเพื่อรับตั๋ว",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "ทำภารกิจต่อไปนี้ให้สำเร็จ คุณจะได้รับตั๋วตามจำนวนที่สอดคล้องกันเพื่อเข้าร่วมการแข่งขัน",
  时: "เวลา",
  活动: "กิจกรรม",
  竞猜记录: "คาดเดาบันทึก",
  结果: "ผลลัพธ์",
  任务: "งาน",
  去邀请: "เพื่อเชิญ",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "การเดาคะแนนในแต่ละเกม การเข้าร่วมการเดาคะแนนสามารถแบ่งรางวัลได้ ${0} USD",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "การเข้าร่วมตอบคำถามต้องใช้ตั๋วซึ่งสามารถรับได้ตามภารกิจของแพลตฟอร์ม",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "เมื่อการทายผลประสบความสำเร็จ ให้ส่งภาพหน้าจอผลการทายผลไปยังฝ่ายบริการลูกค้า ซึ่งฝ่ายบริการลูกค้าจะโอนเงินรางวัลเข้าบัญชีเงินทุนของคุณ ซึ่งคุณสามารถถอนเงินได้ทันที",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "ห้ามทำการโกงใด ๆ และรางวัลจะถือเป็นโมฆะหากพบการโกง",
  "完成任务后，点击咨询客服获得门票。":
    "หลังจากเสร็จสิ้นงาน คลิกปรึกษาฝ่ายบริการลูกค้าเพื่อรับตั๋ว",
  继续猜: "คาดเดาต่อไป",
  总单数: "เอกพจน์ทั้งหมด",
  赛事筛选: "การคัดกรองเหตุการณ์",
  球队筛选: "การเลือกทีม",
  总金额: "เงินก้อน",
  总流水: "มูลค่าการซื้อขายรวม",
  派奖金额: "จำนวนโบนัส",
  下注单数: "เดิมพันเลขคี่",
  利润: "กำไร",
  更多福利: "ประโยชน์มากขึ้น",
  我的奖金: "โบนัสของฉัน",
  未认证: "ไม่ได้รับการรับรอง",
  总量: "ทั้งหมด",
  或: "หรือ",
  模拟交易: "การซื้อขายสาธิต",
  体验账户不可操作: "บัญชีประสบการณ์ใช้งานไม่ได้",
  世界杯比分竞猜: "แบบทดสอบคะแนนฟุตบอลโลก",
  "领*USDT起": "รับ {0}USDT จาก",
  消息: "ข้อมูล",
  滚球: "Bóng lăn",
  是: "ใช่",
  不是: "ไม่มี",
  当前余额: "ยอดเงินปัจจุบัน",
  KOL招募: "รับสมัคร KOL",
  本月净输赢: "ชนะ/แพ้สุทธิสำหรับเดือน",
  本月佣金: "ค่าคอมมิชชั่นของเดือน",
  佣金比例: "อัตราค่านายหน้า",
  活跃人数: "หมายเลขที่ใช้งาน",
  新增下级: "เพิ่มผู้ใต้บังคับบัญชา",
  登录人数: "จำนวนการเข้าสู่ระบบ",
  首存人数: "จำนวนผู้ฝากครั้งแรก",
  数据分析: "การวิเคราะห์ข้อมูล",
  人数: "จำนวนคน",
  新注册存款金额: "จำนวนเงินฝากที่ลงทะเบียนใหม่",
  老用户存款金额: "จำนวนเงินฝากของผู้ใช้เก่า",
  首存金额: "จำนวนเงินฝากครั้งแรก",
  快捷入口: "รายการด่วน",
  成员管理: "การจัดการสมาชิก",
  财务报表: "งบการเงิน",
  分红报表: "รายงานการจ่ายเงินปันผล",
  订单记录: "บันทึกการสั่งซื้อ",
  VIP专享: "วีไอพี เอ็กซ์คลูซีฟ",
  推广工具: "เครื่องมือส่งเสริมการขาย",
  计算规则: "กฎการคำนวณ",
  账变明细: "รายละเอียดการเปลี่ยนแปลงบัญชี",
  成员: "สมาชิก",
  下级概览: "ภาพรวมของผู้ใต้บังคับบัญชา",
  下级成员总计: "รวมสมาชิกผู้ใต้บังคับบัญชา",
  本月新增: "ใหม่เดือนนี้",
  本月活跃会员: "สมาชิกที่ใช้งานประจำเดือน",
  今日活跃会员: "สมาชิกที่ใช้งานวันนี้",
  本月有效活跃: "ใช้งานในเดือนนี้",
  活跃成员占比: "สัดส่วนสมาชิกที่ใช้งานอยู่",
  本月活跃: "ใช้งานในเดือนนี้",
  今日活跃: "ใช้งานวันนี้",
  下级成员: "สมาชิกรุ่นเยาว์",
  会员账号: "บัญชีสมาชิก",
  统计时间: "เวลาสถิติ",
  筛选: "กรอง",
  存款: "เงินฝาก",
  取款: "เบิกเงิน",
  总输赢: "ชนะหรือแพ้ทั้งหมด",
  是否有效用户: "เป็นผู้ใช้ที่ถูกต้องหรือไม่",
  最近登录时间: "เวลาเข้าสู่ระบบล่าสุด",
  否: "ไม่",
  开始时间: "เวลาเริ่มต้น",
  结束时间: "เวลาสิ้นสุด",
  提取: "สารสกัด",
  总盈亏: "กำไรและขาดทุนทั้งหมด",
  净盈亏: "กำไรสุทธิและขาดทุน",
  分红: "เงินปันผล",
  概览: "ภาพรวม",
  月度详细数据: "ข้อมูลรายเดือนโดยละเอียด",
  未发放: "ไม่ออก",
  活跃用户: "ผู้ใช้ที่ใช้งานอยู่",
  有效新增会员: "เพิ่มสมาชิกใหม่อย่างมีประสิทธิภาพ",
  冲正后净输赢: "ชนะหรือแพ้สุทธิหลังจากการล้าง",
  上月结余: "ยอดของเดือนที่แล้ว",
  净输赢: "ชนะ/แพ้สุทธิ",
  "系统每日新加坡时间1:00更新一次报表":
    "ระบบจะปรับปรุงรายงานทุกวันเวลา 1:00 น. ตามเวลาสิงคโปร์",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "ตัวเลขที่เป็นบวกในข้อมูล การชนะและการสูญเสียทั้งหมด และการชนะและการแพ้สุทธิในรายงานจะระบุถึงผลกำไรของตัวแทน และตัวเลขที่เป็นลบบ่งชี้ถึงการขาดทุนของตัวแทน",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "ข้อมูลค่าคอมมิชชั่นได้รับการอัพเดททุกวันและใช้สำหรับการอ้างอิงเท่านั้น ไม่ใช่มาตรฐานการกระจายค่าคอมมิชชั่นจริง",
  选择时间: "ระยะเวลาคัดเลือก",
  足球: "ฟุตบอล",
  投注金额: "จำนวนเงินเดิมพัน",
  有效订单: "คำสั่งที่ถูกต้อง",
  下级账户: "บัญชีรอง",
  待成交: "ข้อตกลงที่รอดำเนินการ",
  下单金额: "จำนวนการสั่งซื้อ",
  订单内容: "สั่งซื้อเนื้อหา",
  秒数: "วินาที",
  联赛: "ลีก",
  队伍: "ทีม",
  比赛时间: "เวลาแข่งขัน",
  玩法: "วิธีการเล่น",
  等级规则表: "ตารางกฎเกรด",
  等级: "ระดับ",
  活跃会员: "สมาชิกที่ใช้งานอยู่",
  最新活跃: "ใช้งานล่าสุด",
  额外佣金: "ค่าคอมมิชชั่นพิเศษ",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "มาตรฐานการเติบโตและระบบรางวัลของระดับที่สอดคล้องกันถูกนำมาใช้ทุกเดือน และสามารถเพลิดเพลินกับรางวัลระดับเดียวเท่านั้น",
  渠道生成: "การสร้างช่อง",
  创建: "สร้าง",
  渠道名称: "ชื่อช่อง",
  注册人数: "จำนวนผู้ลงทะเบียน",
  浏览人数: "ผู้ชม",
  构建状态: "สร้างสถานะ",
  禁用: "พิการ",
  启用: "เปิดใช้งาน",
  查看: "ตรวจสอบ",
  创建渠道: "สร้างช่อง",
  创建成功: "สร้างสำเร็จแล้ว",
  操作成功: "การดำเนินการที่ประสบความสำเร็จ",
  渠道详情: "รายละเอียดช่อง",
  邀请码: "รหัสการเชิญ",
  访问人数: "จำนวนผู้เข้าชม",
  渠道地址: "ที่อยู่ช่อง",
  我的福利: "ผลประโยชน์ของฉัน",
  充值福利: "เติมเงินผลประโยชน์",
  当前流水: "กระแส",
  如何参与: "วิธีเข้าร่วม",
  币种充值: "เติมเงินสกุลเงิน",
  充值福利中领取福利: "รับสิทธิประโยชน์จากการเติมเงิน",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "กฎ: ผลประโยชน์การเติมเงินเป็นไปโดยสมัครใจที่จะรับและระยะเวลาที่ใช้ได้คือภายใน 24 ชั่วโมงหลังจากการเติม มันจะใช้ไม่ได้หลังจากวันหมดอายุ หลังจากได้รับแล้ว ฟังก์ชั่นการถอนเงินสดจะถูกล็อคชั่วคราวและสามารถถอนเงินสดได้ ปลดล็อกเมื่อถึงยอดเทิร์นโอเวอร์",
  失效日期: "วันหมดอายุ",
  "暂无福利领取，充值后领取":
    "ยังไม่ได้รับสิทธิประโยชน์ รับหลังจากเติมเงินแล้ว",
  参与: "มีส่วนร่วม",
  充值赠送: "ของขวัญเติมเงิน",
  "领取*%的赠送": "รับของขวัญ {0}%",
  去领取: "เพื่อรวบรวม",
  VIP奖励: "รางวัลวีไอพี",
  "当前可领取*USDT，是否确认领取":
    "สามารถรับ {0}USDT ได้ในปัจจุบัน คุณยืนยันการเรียกร้องหรือไม่?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "หลังจากอ้างสิทธิ์แล้ว ฟังก์ชันการถอนเงินจะถูกล็อคชั่วคราว และสามารถปลดล็อคได้เมื่อมูลค่าการซื้อขายของคุณถึง {0}USDT",
  充值送大礼: "เติมเงินเพื่อรับของขวัญชิ้นใหญ่",
  "存入越多，送越多！": "ยิ่งฝากมาก ยิ่งได้มาก!",
  无效: "ไม่ถูกต้อง",
  有效: "มีประสิทธิภาพ",
  总存金额: "จำนวนเงินฝากทั้งหมด",
  提示: "คำใบ้",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "ตัวเลขบวกในการชนะและแพ้ทั้งหมดและการชนะและแพ้สุทธิบ่งชี้ถึงผลกำไรของแพลตฟอร์มและตัวเลขที่เป็นลบบ่งชี้ถึงการขาดทุน ข้อมูลรายวัน ใช้สำหรับการอ้างอิงเท่านั้นและไม่ได้ทำหน้าที่เป็นมาตรฐานการกระจายค่าคอมมิชชันที่แท้จริง",
  "净盈亏：总盈亏-用户返水":
    "กำไรและขาดทุนสุทธิ: กำไรและขาดทุนทั้งหมด - เงินคืนผู้ใช้",
  盈利方: "ปาร์ตี้ที่ทำกำไรได้",
  代理: "การแสดง",
  客户: "ลูกค้า",
  平局: "วาด",
  平台: "แพลตฟอร์ม",
  "已提交审核，请耐心等待": "ส่งเพื่อตรวจสอบแล้ว โปรดอดใจรอ",
  充值日期: "วันที่เติมเงิน",
  平台本月总输赢: "ชัยชนะและการสูญเสียทั้งหมดของแพลตฟอร์มในเดือนนี้",
  KOL招募合作: "ความร่วมมือในการสรรหา KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "แพลตฟอร์มเปิดแล้ว [KOL Recruitment Event] ตราบใดที่คุณมีบัญชีโซเชียลมีเดีย คุณสามารถรับโบนัสครั้งเดียวกับแพลตฟอร์มเพื่อโปรโมตลูกค้า และรับสิทธิประโยชน์ตลอดชีพ",
  级别: "ระดับ",
  平台利润返佣: "ส่วนลดกำไรจากแพลตฟอร์ม",
  佣金案例: "กรณีคณะกรรมการ",
  交易项目: "รายการธุรกรรม",
  "期权交易、合约交易、足球游戏": "การซื้อขายออปชั่น การซื้อขายสัญญา เกมฟุตบอล",
  报名方式: "วิธีการลงทะเบียน",
  点击KOL招募报名: "คลิกลงทะเบียนรับสมัคร KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "ยินดีต้อนรับสู่การเข้าร่วมทีมของเรา แพลตฟอร์มนี้สนับสนุนคุณอย่างเต็มที่ในการสร้างระบบผู้ใช้ของคุณเอง และคุณจะได้รับค่าคอมมิชชั่นสูงสุด{0} เราหวังว่าจะได้เข้าร่วมกับคุณ",
  输入联系方式: "ป้อนข้อมูลการติดต่อ",
  最低活跃人数: "จำนวนที่ใช้งานขั้นต่ำ",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "ตัวอย่างเช่น: จำนวนผู้ใช้ที่ใช้งานในเดือนนี้ ≥ {0} และการชนะหรือแพ้ทั้งหมดของแพลตฟอร์มในเดือนนี้ ≥ {1}USDT คุณอยู่ในระดับ {2} คุณจะได้รับค่าคอมมิชชัน {3}%",
  比分竞猜: "ทายผลคะแนน",
  豪礼相赠: "ของขวัญสุดหรู",
  足球活动: "กิจกรรมฟุตบอล",
  圣诞节活动: "กิจกรรมคริสต์มาส",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "คุณได้เข้าร่วมกิจกรรม, คุณสมบัติการถอนล็อคชั่วคราว, และยัง {0} USDT ไหลน้ำเพื่อปลดล็อค.",
  剩余流水: "เหลือน้ำไหล",
  助力足球: "ฟุตบอลช่วย",
  佣金累计: "ค่าคอมมิชชั่นทั้งหมด",
  有效投注: "เดิมพันที่ถูกต้อง",
  今日: "วันนี้",
  今日返水: "ส่วนลดวันนี้",
  VIP返水: "ส่วนลดวีไอพี",
  返水记录: "บันทึกการคืนเงิน",
  成员信息: "ข้อมูลสมาชิก",
  基本信息: "ข้อมูลพื้นฐาน",
  钱包余额: "ยอดคงเหลือในกระเป๋าเงิน",
  投注信息: "ข้อมูลการเดิมพัน",
  返水: "ส่วนลด",
  总下注: "เดิมพันทั้งหมด",
  今日输赢: "ชนะหรือแพ้ในวันนี้",
  下注动态: "การเดิมพันแบบไดนามิก",
  返水奖励: "โบนัสเงินคืน",
  分红金额: "จำนวนเงินปันผล",
  返水支出: "การจ่ายเงินคืน",
  总返水: "ส่วนลดทั้งหมด",
  流水总额: "มูลค่าการซื้อขายรวม",
  返水总额: "เงินคืนทั้งหมด",
  返水详情: "รายละเอียดการคืนเงิน",
  日流水: "น้ำทุกวัน",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "แพลตฟอร์มนี้ให้รางวัลเงินคืนเพิ่มเติมตามยอดเทิร์นโอเวอร์รายวันของผู้ใต้บังคับบัญชา และรางวัลจะถูกแจกจ่ายไปยังบัญชีรางวัลทุกวันเวลา 00:00 น. ตามเวลาสิงคโปร์",
  "申请成功，等待审核": "การสมัครสำเร็จแล้ว กำลังรอการตรวจสอบ",
  "我出本金，盈利共分享": "ฉันจ่ายเงินต้นและแบ่งผลกำไร",
  最高分红: "เงินปันผลสูงสุด",
  投资大师比赛: "การแข่งขันปริญญาโทการลงทุน",
  "我出本金，你盈利": "ฉันจ่ายเงินต้น คุณก็ได้กำไร",
  共分享: "ใช้ร่วมกัน",
  最高分红可得: "เงินปันผลสูงสุดที่มีอยู่",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "สิทธิประโยชน์พิเศษสำหรับผู้ใช้ใหม่กำลังจะมา ฟรี ${0} คุณสามารถลงทุนในโครงการใดก็ได้บนแพลตฟอร์มหลังจากได้รับ และคุณสามารถถอนได้ทันทีหลังจากทำกำไร",
  报名领取: "ลงทะเบียนเพื่อรับ",
  已领取: "ได้รับ",
  审核驳回: "รีวิวถูกปฏิเสธ",
  驳回原因: "เหตุผลในการปฏิเสธ",
  活动运行周期: "รอบวิ่งกิจกรรม",
  "申请成功后起至*天内完成超额收益。":
    "หลังจากสมัครสำเร็จ รายได้ส่วนเกินจะเสร็จสิ้นภายใน {0} วัน",
  分红比: "อัตราส่วนเงินปันผล",
  "*日获得盈利后，可获得*%的收益额。":
    "หลังจากได้กำไรในวันที่ {0} คุณจะได้รับ {1}% ของกำไร",
  参与条件: "เงื่อนไขการเข้าร่วม",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "ผู้ใช้ในรัสเซียและตุรกีไม่ได้เข้าร่วม",
  计算项目: "รายการคำนวณ",
  "合约、体育、期权": "สัญญา กีฬา ตัวเลือก",
  我的投资: "การลงทุนของฉัน",
  参与天数: "วันที่เข้าร่วม",
  累计下注: "เดิมพันสะสม",
  累计盈亏: "กำไรขาดทุนสะสม",
  预计可分红: "คาดว่าจะจ่ายเงินปันผล",
  常见问题: "ปัญหาที่พบบ่อย",
  什么是平台出资: "เงินทุนแพลตฟอร์มคืออะไร",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "ตามผู้ใช้ในบางประเทศ แพลตฟอร์มให้เงินทุนฟรีสำหรับผู้ใช้เพื่อลงทุนในโครงการ",
  怎么获取平台出资的福利: "วิธีรับผลประโยชน์จากการสนับสนุนแพลตฟอร์ม",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "คุณต้องเป็นผู้ใช้ในประเทศที่กำหนดเท่านั้น คลิกปุ่มลงทะเบียนด้านบน และ {0}USDT จะถูกโอนไปยังบัญชีรางวัลภายใต้บัญชีปัจจุบันหลังจากการตรวจสอบแพลตฟอร์มเสร็จสิ้น และคุณสามารถโอนไปยังบัญชีอื่นเพื่อการลงทุนได้",
  什么是分红: "เงินปันผลคืออะไร",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "เงินปันผล หมายความว่าภายในระยะเวลาที่กำหนด หลังจากรายได้ถึง 100% จะสามารถแบ่ง 50% ของรายได้ส่วนเกินได้ ตัวอย่างเช่น หากต้องการรับเงิน 100USDT จำนวนรายได้คือ 120%",
  "如何取得分红？": "ทำอย่างไรจึงจะได้เงินปันผล?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "รอบกิจกรรมคือทุกๆ {0}วัน หลังจากกิจกรรมสิ้นสุดลง จะมีการคำนวณ และจะจ่ายเงินปันผลไปยังบัญชีรางวัลหลังจากผ่านเกณฑ์กิจกรรม หากคุณไม่ปฏิบัติตามข้อกำหนดของกิจกรรม ระบบจะล้างรายได้และการสนับสนุนแพลตฟอร์มของคุณโดยอัตโนมัติ",
  活动规则: "กติกากิจกรรม",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "บัญชีที่เข้าร่วมต้องผ่านการตรวจสอบ KYC และแต่ละบัญชีจะจำกัดเพียงหนึ่งสิทธิประโยชน์เท่านั้น",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC ของบัญชีที่เข้าร่วมกำหนดให้ประเทศที่ระบุเข้าร่วมและภูมิภาคอื่นๆ ไม่ได้รับอนุญาตให้เข้าร่วม โปรดตรวจสอบว่าประเทศที่ใช้งานอยู่นั้นสอดคล้องกับประเทศของคุณหรือไม่",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "หลังจากเข้าร่วมกิจกรรมสำเร็จ บัญชีจะล็อกฟังก์ชันถอนเงินของคุณชั่วคราว และฟังก์ชันถอนเงินของคุณจะถูกปลดหลังจากกิจกรรมเสร็จสิ้น",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "โปรดปฏิบัติตามกฎกิจกรรมของแพลตฟอร์ม หากคุณพบการโกงหรือใช้ประโยชน์จากช่องโหว่ของระบบเพื่อผลกำไร แพลตฟอร์มจะระงับเงินทั้งหมดไว้ในบัญชีของคุณเป็นเวลานาน",
  平台出资: "การลงทุนแพลตฟอร์ม",
  平台出资收回: "การกู้คืนการลงทุนแพลตฟอร์ม",
  投资大师奖励: "รางวัลต้นแบบการลงทุน",
  请下载APP添加收款方式: "โปรดดาวน์โหลด APP เพื่อเพิ่มวิธีการชำระเงิน",
  请下载APP进行身份验证: "โปรดดาวน์โหลด APP เพื่อการยืนยันตัวตน",
  请下载APP参与: "โปรดดาวน์โหลดแอปเพื่อเข้าร่วม",
  技术指标: "ตัวชี้วัดทางเทคนิค",
  主图: "ภาพหลัก",
  副图: "ภาพย่อย",
  新注册人数: "ผู้ลงทะเบียนใหม่",
  老用户存款人数: "เงินฝากผู้ใช้เก่า",
  存款人数: "จำนวนผู้ฝาก",
  取款人数: "จำนวนการถอน",
  投注人数: "จำนวนนักพนัน",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "ยกเว้นอินโดนีเซีย อินเดีย บังคลาเทศ และผู้ใช้ที่ไม่ได้เข้าร่วม",
  市场动态: "การเปลี่ยนแปลงของตลาด",
  外汇合约: "สัญญาแลกเปลี่ยนเงินตราต่างประเทศ",
  盈亏比: "อัตราส่วนกำไร-ขาดทุน",
  委托价: "ราคาสั่ง",
  可用余额: "ยอดเงินคงเหลือ",
  持仓额: "จำนวนตำแหน่ง",
  强平价: "ความเท่าเทียมกันที่แข็งแกร่ง",
  修改: "ปรับปรุงใหม่",
  修改价位: "ปรับเปลี่ยนราคา",
  外汇: "ฟอเร็กซ์",
  外汇账户: "บัญชีฟอเร็กซ์",
  我的交易: "ธุรกรรมของฉัน",
  未设置: "ไม่ได้ตั้งค่า",
  超出最大可设数值: "เกินค่าที่กำหนดสูงสุดได้",
  超出最小可设数值: "เกินค่าขั้นต่ำที่กำหนดได้",
  止盈超出最小可设数值: "ทำกำไรเกินมูลค่าขั้นต่ำที่กำหนดได้",
  止损超出最大可设数值: "หยุดการสูญเสียเกินค่าสูงสุดที่กำหนดได้",
  止盈超出最大可设数值: "ทำกำไรเกินมูลค่าสูงสุดที่กำหนดได้",
  止损超出最小可设数值: "หยุดการสูญเสียเกินค่าขั้นต่ำที่กำหนดได้",
  挖矿: "การทำเหมืองแร่",
  交易账户: "บัญชีธุรกรรม",
  买涨: "ซื้อ",
  买跌: "ซื้อหรือขาย",
  请输入正确的银行卡信息: "กรุณาป้อนข้อมูลบัตรธนาคารที่ถูกต้อง",
  联系在线客服: "ติดต่อฝ่ายบริการลูกค้าออนไลน์",
  法币交易请联系在线客服:
    "สำหรับธุรกรรมสกุลเงินตามกฎหมาย โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์",
  提交订单: "ส่งคำสั่งซื้อ",
  "支付过程如有疑问,请联系在线客服":
    "หากคุณมีคำถามใดๆ เกี่ยวกับขั้นตอนการชำระเงิน โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์",
  彩金赠送: "แจกทองสี",
  在线客服: "บริการออนไลน์",
  最少投资: "การลงทุนขั้นต่ำ",
  "提交时间:": "เวลาส่ง:",
  提现拒绝: "การถอนเงินถูกปฏิเสธ",
  认证拒绝: "การรับรองความถูกต้องถูกปฏิเสธ",
  认证通过: "ผ่านการรับรองแล้ว",
  请输入正确的交易额度: "กรุณากรอกจำนวนธุรกรรมที่ถูกต้อง",
  最大下注金额: "จำนวนเงินเดิมพันสูงสุด",
  手机号: "หมายเลขโทรศัพท์",
  邮箱注册: "การลงทะเบียนอีเมล",
  手机号注册: "การลงทะเบียนหมายเลขโทรศัพท์มือถือ",
  查询: "สอบถาม",
  手机号登录: "เข้าสู่ระบบหมายเลขโทรศัพท์มือถือ",
  邮箱登录: "เข้าสู่ระบบอีเมล",
  请输入数量: "กรุณากรอกจำนวน",
  可用数量: "ปริมาณที่มีอยู่",
  钱包登录: "เข้าสู่ระบบกระเป๋าเงิน",
  请输入正确的邀请码: "กรุณากรอกรหัสเชิญที่ถูกต้อง",
  "请输入邀请码(必填)": "กรุณากรอกรหัสเชิญ (จำเป็น)",
  输入正确的金额: "กรอกจำนวนเงินที่ถูกต้อง",
  法币充值: "เติมเงินด้วยสกุลเงินของประเทศ",
  卢比充值: "เติมเงินเรูปี",
  请输入法币: "กรุณาใส่เงินตรา",
  请输入IFSC: "โปรดใส่ IFSC",
  "银行编码(选填)": "รหัสธนาคาร (ตัวเลือก)",
  请输入银行编码: "โปรดใส่รหัสธนาคาร",
  请输入大于8位数的密码: "กรุณากรอกรหัสผ่านที่มากกว่า 8 หลัก",
  添加成功: "เพิ่มเรียบร้อยแล้ว",
  "60秒": "60 วินาที",
  "180秒": "180 วินาที",
  "300秒": "300 วินາที",
  "2次密码不一致": "รหัสผ่าน 2 รหัสไม่ตรงกัน",
  输入提币数量: "ป้อนจำนวนเงินที่ถอน",
  图片格式不正确: "รูปแบบภาพไม่ถูกต้อง",
  图片大于20M: "ขนาดภาพใหญ่กว่า 20M",
  请设置委托价格: "โปรดตั้งราคาค่ามอบหมาย",
  输入资金密码: "กรุณาใส่รหัสเงินทุน",
  验证码错误: "ข้อผิดพลาดรหัสยืนยัน",
  充值拒绝: "การเติมเงินถูกปฏิเสธ",
  请输入SSN: "กรุณากรอก SSN",
  合约交易: "การซื้อขายตามสัญญา",
  结算完成: "การชำระเงินเสร็จสมบูรณ์",
  继续下单: "ดำเนินการสั่งซื้อ",
  最低购买: "ซื้อขั้นต่ำ",
  最高购买: "การซื้อสูงสุด",
  限价: "ราคา จำกัด",
  买入价格: "ราคาซื้อ",
  买入量: "ปริมาณการซื้อ",
  卖出价格: "ราคาขาย",
  卖出量: "ปริมาณการขาย",
  买入: "ซื้อ",
  卖出: "ขาย",
  订单创建成功: "สร้างคำสั่งเรียบร้อยแล้ว",
  币币买入支出: "ค่าใช้จ่ายในการซื้อคริปโต",
  币币买入支出退还: "คืนค่าใช้จ่ายในการซื้อคริปโต",
  币币买入获得: "ได้รับคริปโตจากการซื้อ",
  币币卖出支出: "ค่าใช้จ่ายในการขายคริปโต",
  币币卖出支出退还: "คืนค่าใช้จ่ายในการขายคริปโต",
  币币卖出获得: "ได้รับคริปโตจากการขาย",
  币币交易手续费: "ค่าธรรมเนียมการทำธุรกรรมคริปโต",
  请输入限价: "กรุณาใส่ราคาจำกัด",
  成交: "เสร็จสมบูรณ์",
  等待成交: "รอการทำธุรกรรม",
  交易完成: "ธุรกรรมเสร็จสมบูรณ์",
  被取消: "ถูกยกเลิก",
  交易时间: "เวลาทำธุรกรรม",

  法币交易: "การแลกเปลี่ยนสกุลเงินฟิแอท",
  法币出售: "การขายสกุลเงินฟิแอท",
  两次密码不一致: "รหัสผ่านทั้งสองไม่ตรงกัน",
  再次输入账户密码: "กรุณาใส่รหัสผ่านบัญชีอีกครั้ง",

  美国: "สหรัฐอเมริกา",
  韩国: "เกาหลีใต้",
  阿尔巴尼亚: "แอลเบเนีย",
  津巴布韦: "ซิมบับเว",
  赞比亚: "แซมเบีย",
  也门: "เยเมน",
  美属维尔京群岛: "หมู่เกาะเวอร์จินของสหรัฐอเมริกา",
  英属处女群岛: "หมู่เกาะบริติชเวอร์จิน",
  越南: "เวียดนาม",
  委内瑞拉: "เวเนซุเอลา",
  瓦努阿图: "วานูอาตู",
  乌兹别克斯坦: "อุซเบกิสถาน",
  乌拉圭: "อุรุกวัย",
  英国: "สหราชอาณาจักร",
  阿拉伯联合酋长国: "สหรัฐอาหรับเอมิเรตส์",
  乌克兰: "ยูเครน",
  乌干达: "ยูกันดา",
  特克斯和凯科斯群岛: "หมู่เกาะเติกส์และเคคอส",
  土库曼斯坦: "เติร์กเมนิสถาน",
  土耳其: "ตุรกี",
  突尼斯: "ตูนิเซีย",
  特立尼达和多巴哥: "ตรินิแดดและโตเบโก",
  汤加: "ตองกา",
  多哥: "โตโก",
  东帝汶: "ติมอร์-เลสเต",
  泰国: "ไทย",
  坦桑尼亚: "แทนซาเนีย",
  塔吉克斯坦: "ทาจิกิสถาน",
  中国台湾: "ไต้หวัน (จีน)",
  叙利亚: "ซีเรีย",
  瑞士: "สวิตเซอร์แลนด์",
  瑞典: "สวีเดน",
  斯威士兰: "เอสวาตีนี",
  苏里南: "ซูรินาม",
  苏丹: "ซูดาน",
  斯里兰卡: "ศรีลังกา",
  西班牙: "สเปน",
  南非: "แอฟริกาใต้",
  索马里: "โซมาเลีย",
  所罗门群岛: "หมู่เกาะโซโลมอน",
  斯洛文尼亚: "สโลวีเนีย",
  斯洛伐克: "สโลวาเกีย",
  "圣马丁岛（荷兰部分）": "เซนต์มาร์ติน (เนเธอร์แลนด์)",
  新加坡: "สิงคโปร์",
  塞拉利昂: "เซียร์ราลีโอน",
  塞舌尔: "เซเชลส์",
  塞尔维亚: "เซอร์เบีย",
  塞内加尔: "เซเนกัล",
  沙特阿拉伯: "ซาอุดีอาระเบีย",
  圣多美和普林西比: "เซาตูเมและปรินซิปี",
  圣马力诺: "ซานมารีโน",
  萨摩亚: "ซามัว",
  圣克里斯托弗和尼维斯: "เซนต์คิตส์และเนวิส",
  圣文森特和格林纳丁斯: "เซนต์วินเซนต์และเกรนาดีนส์",
  圣彼埃尔和密克隆岛: "แซงปีแยร์และมีเกอลง",
  圣露西亚: "เซนต์ลูเซีย",
  圣基茨和尼维斯: "เซนต์คิตส์และเนวิส",
  卢旺达: "รวันดา",
  俄罗斯: "รัสเซีย",
  罗马尼亚: "โรมาเนีย",
  留尼汪: "เรอูนียง",
  刚果共和国: "สาธารณรัฐคองโก",
  卡塔尔: "กาตาร์",
  波多黎各: "เปอร์โตริโก",
  葡萄牙: "โปรตุเกส",
  波兰: "โปแลนด์",
  菲律宾: "ฟิลิปปินส์",
  秘鲁: "เปรู",
  巴拉圭: "ปารากวัย",
  巴布亚新几内亚: "ปาปัวนิวกินี",
  巴拿马: "ปานามา",
  巴勒斯坦: "ปาเลสไตน์",
  帕劳: "ปาเลา",
  巴基斯坦: "ปากีสถาน",
  阿曼: "โอมาน",
  挪威: "นอร์เวย์",
  尼日利亚: "ไนจีเรีย",
  尼日尔: "ไนเจอร์",
  尼加拉瓜: "นิการากัว",
  新西兰: "นิวซีแลนด์",
  新喀里多尼亚: "นิวแคลิโดเนีย",
  荷属安德列斯群岛: "เนเธอร์แลนด์แอนทิลลิส",
  荷兰: "เนเธอร์แลนด์",
  尼泊尔: "เนปาล",
  纳米比亚: "นามิเบีย",
  缅甸: "เมียนมา",
  莫桑比克: "โมซัมบิก",
  摩洛哥: "โมร็อกโก",
  蒙特塞拉特岛: "มอนต์เซอร์รัต",
  黑山: "มอนเตเนโกร",
  蒙古: "มองโกเลีย",
  摩纳哥: "โมนาโก",
  摩尔多瓦: "มอลโดวา",
  墨西哥: "เม็กซิโก",
  马约特: "มายอต",
  毛里求斯: "มอริเชียส",
  毛里塔尼亚: "มอริเตเนีย",
  马里亚纳群岛: "หมู่เกาะมาเรียนา",
  马提尼克: "มาร์ตินีก",
  马耳他: "มอลตา",
  马里: "มาลี",
  马尔代夫: "มัลดีฟส์",
  马来西亚: "มาเลเซีย",
  马拉维: "มาลาวี",
  马达加斯加: "มาดากัสการ์",
  马其顿: "นอร์ทมาซิโดเนีย",
  中国澳门: "มาเก๊า (จีน)",
  卢森堡: "ลักเซมเบิร์ก",
  立陶宛: "ลิทัวเนีย",
  列支敦士登: "ลิกเตนสไตน์",
  利比亚: "ลิเบีย",
  利比里亚: "ไลบีเรีย",
  莱索托: "เลโซโท",
  黎巴嫩: "เลบานอน",
  拉脱维亚: "ลัตเวีย",
  老挝: "ลาว",
  吉尔吉斯斯坦: "คีร์กีซสถาน",
  科威特: "คูเวต",
  基里巴斯: "คิริบาส",
  肯尼亚: "เคนยา",
  哈萨克斯坦: "คาซัคสถาน",
  约旦: "จอร์แดน",
  日本: "ญี่ปุ่น",
  牙买加: "จาเมกา",
  象牙海岸: "โกตดิวัวร์",
  意大利: "อิตาลี",
  以色列: "อิสราเอล",
  爱尔兰: "ไอร์แลนด์",
  伊拉克: "อิรัก",
  伊朗: "อิหร่าน",
  印度尼西亚: "อินโดนีเซีย",
  印度: "อินเดีย",
  冰岛: "ไอซ์แลนด์",
  匈牙利: "ฮังการี",
  中国香港: "ฮ่องกง (จีน)",
  洪都拉斯: "ฮอนดูรัส",
  海地: "เฮติ",
  圭亚那: "กายอานา",
  几内亚比绍共和国: "กินี-บิสเซา",
  几内亚: "กินี",
  危地马拉: "กัวเตมาลา",
  关岛: "กวม",
  瓜德罗普岛: "กวาเดอลูป",
  格林纳达: "เกรเนดา",
  格陵兰岛: "กรีนแลนด์",
  希腊: "กรีซ",
  直布罗陀: "ยิบรอลตาร์",
  加纳: "กานา",
  德国: "เยอรมนี",
  格鲁吉亚: "จอร์เจีย",
  冈比亚: "แกมเบีย",
  加蓬: "กาบอง",
  法属波利尼西亚: "เฟรนช์โปลินีเซีย",
  法属圭亚那: "เฟรนช์เกียนา",
  法国: "ฝรั่งเศส",
  芬兰: "ฟินแลนด์",
  斐济: "ฟิจิ",
  法罗群岛: "หมู่เกาะแฟโร",
  埃塞俄比亚: "เอธิโอเปีย",
  爱沙尼亚: "เอสโตเนีย",
  厄立特里亚: "เอริเทรีย",
  赤道几内亚: "อิเควทอเรียลกินี",
  萨尔瓦多: "เอลซัลวาดอร์",
  埃及: "อียิปต์",
  厄瓜多尔: "เอกวาดอร์",
  多米尼加共和国: "สาธารณรัฐโดมินิกัน",
  多米尼加: "โดมินิกา",
  吉布提: "จิบูตี",
  丹麦: "เดนมาร์ก",
  捷克: "เช็กเกีย",
  塞浦路斯: "ไซปรัส",
  库拉索: "คูราเซา",
  古巴: "คิวบา",
  克罗地亚: "โครเอเชีย",
  哥斯达黎加: "คอสตาริกา",
  科特迪瓦: "โกตดิวัวร์",
  库克群岛: "หมู่เกาะคุก",
  科摩罗: "คอโมโรส",
  哥伦比亚: "โคลอมเบีย",
  智利: "ชิลี",
  乍得: "ชาด",
  中非共和国: "สาธารณรัฐแอฟริกากลาง",
  佛得角: "เคปเวิร์ด",
  开曼群岛: "หมู่เกาะเคย์แมน",
  开普: "เคป",
  加拿大: "แคนาดา",
  喀麦隆: "แคเมอรูน",
  柬埔寨: "กัมพูชา",
  布隆迪: "บุรุนดี",
  布基纳法索: "บูร์กินาฟาโซ",
  保加利亚: "บัลแกเรีย",
  文莱: "บรูไน",
  巴西: "บราซิล",
  博茨瓦纳: "บอตสวานา",
  波斯尼亚和黑塞哥维那: "บอสเนียและเฮอร์เซโกวีนา",
  玻利维亚: "โบลิเวีย",
  不丹: "ภูฏาน",
  百慕大群岛: "เบอร์มิวดา",
  贝宁: "เบนิน",
  伯利兹: "เบลีซ",
  比利时: "เบลเยียม",
  白俄罗斯: "เบลารุส",
  巴巴多斯: "บาร์เบโดส",
  孟加拉国: "บังกลาเทศ",
  巴林: "บาห์เรน",
  巴哈马: "บาฮามาส",
  阿塞拜疆: "อาเซอร์ไบจาน",
  奥地利: "ออสเตรีย",
  澳大利亚: "ออสเตรเลีย",
  阿鲁巴: "อารูบา",
  亚美尼亚: "อาร์เมเนีย",
  阿根廷: "อาร์เจนตินา",
  安提瓜和巴布达: "แอนติกาและบาร์บูดา",
  安圭拉: "แองกวิลลา",
  安哥拉: "แองโกลา",
  安道尔: "อันดอร์รา",
  美属萨摩亚: "อเมริกันซามัว",
  阿尔及利亚: "แอลจีเรีย",
  中国: "จีน",

  日收益: "กำไรรายวัน",
  "30天预期收益": "กำไรคาดว่าจะได้ใน 30 วัน",
  英伟达高速矿机: "เครื่องขุดเหมืองความเร็วสูง NVIDIA",
  去投资: "ไปลงทุน",
  新币榜: "รายการเหรียญใหม่",
  主题: "หัวข้อ",
  立即探索: "สำรวจทันที",
  等您来: "รอคุณอยู่",
  最新活动: "กิจกรรมล่าสุด",
  货币划转: "โอนสกุลเงิน",
  提现钱包: "วอลเล็ตถอนเงิน",
  加密合约: "สัญญาการเข้ารหัส",
  外汇期货: "ฟิวเจอร์สกุลเงินต่างประเทศ",
  定期: "ระยะเวลาประจำ",
  探索产品: "สำรวจผลิตภัณฑ์",
  稳健型: "ประเภทเสถียร",
  高收益: "กำไรสูง",
  期货账户: "บัญชีฟิวเจอร์",
  时间线: "ไลน์เวลา",
  收藏: "รายการโปรด",
  委托订单: "คำสั่งซื้อผ่านตัวแทน",
  最新交易: "การซื้อขายล่าสุด",
  深度图: "แผนภาพความลึก",
  标记价格: "ราคามาร์กเกอร์",
  "24h最高价": "ราคาสูงสุดใน 24 ชั่วโมง",
  "24h成交量": "ปริมาณการซื้อขายใน 24 ชั่วโมง",
  "24h最低价": "ราคาต่ำสุดใน 24 ชั่วโมง",
  "24h成交额": "มูลค่าการซื้อขายใน 24 ชั่วโมง",
  "价格(USDT)": "ราคา (ยูเอสดีทรี)",
  "数量(ETH)": "ปริมาณ (อีเธอร์)",
  看空: "เดิมพันราคาลง",
  余额不足: "ยอดคงเหลือไม่เพียงพอ",
  最低购买: "ขั้นต่ำในการซื้อ",
  最高购买: "สูงสุดในการซื้อ",
  下单成功: "สั่งซื้อสำเร็จ",
  平仓成功: "ปิดพอร์ตสำเร็จ",
  请输入正确的平仓数量: "กรุณากรอกจำนวนการปิดพอร์ตให้ถูกต้อง",
  加仓成功: "เพิ่มพอร์ตสำเร็จ",
  请输入正确的加仓金额: "กรุณากรอกจำนวนเงินเพิ่มพอร์ตให้ถูกต้อง",
  收藏成功: "เพิ่มรายการโปรดสำเร็จ",
  取消收藏成功: "ลบออกจากรายการโปรดสำเร็จ",
  日收益率: "อัตราผลตอบแทนรายวัน",
  轻松理财: "การจัดการการเงินอย่างง่ายดาย",
  立即申购: "สมัครสมาชิกทันที",
  申购日期: "วันที่สมัครสมาชิก",
  加密货币: "สกุลเงินดิจิทัลเข้ารหัส",
  交割合约: "สัญญาการส่งมอบ",
  最小投资: "ขั้นต่ำในการลงทุน",
  委托: "ตัวแทน",
  "当指数价格触达时，将会触发委托平仓":
    "เมื่อราคาอินเด็กซ์ถึงระดับที่กำหนด จะกระตุ้นการปิดพอร์ตผ่านตัวแทน",
  预计盈利: "กำไรคาดว่าจะได้",
  最大投资: "สูงสุดในการลงทุน",
  现货交易: "การซื้อขายคริปโต",
  输入交易金额: "กรุณากรอกจำนวนเงินในการซื้อขาย",
  "可用额度：": "วงเงินที่ใช้ได้:",
  提现货币: "สกุลเงินสำหรับถอน",
  期货合约: "สัญญาฟิวเจอร์",
  加密币永续: "คริปโตแบบไม่มีกำหนด",
  外汇永续: "ฟอเร็กซ์แบบไม่มีกำหนด",
  期权账户: "บัญชีออปชัน",
  夜间模式: "โหมดกลางคืน",
  未结盈亏: "กำไรและขาดทุนที่ยังไม่เกิดขึ้น",
  超额收益: "กำไรส่วนเกิน",
  "安全策略，低买高卖": "นโยบายความปลอดภัย ซื้อน้อยขายสูง",
  投资金额应为: "จำนวนเงินลงทุนควรเป็น",
  总收益率: "อัตราผลตอบแทนรวม",
  赎回成功: "แลกสำเร็จ",
  快捷卖币: "ขายเหรียญด่วน",
  修改止盈止损: "แก้ไข TP/SL",
  白皮书: "เอกสาร whitepaper",
  托管资金: "เงินทุนภายใต้การจัดการ",
  托管中: "กำลังจัดการ",
  预计日收益: "ผลตอบแทนรายวันโดยประมาณ",
  累计收益: "ผลตอบแทนสะสม",
  周期: "รอบระยะเวลา",
  日收益: "ผลตอบแทนรายวัน",
  限额: "วงเงินจำกัด",
  立即托管: "ลงทุนทันที",
  "已鎖定 請聯繫客服": "ถูกล็อก กรุณาติดต่อฝ่ายบริการลูกค้า",
  产品列表: "รายการสินค้า",
  规则: "กฎระเบียบ",
  创建订单: "สร้างคำสั่งซื้อ",
  产品名称: "ชื่อสินค้า",
  托管周期: "ระยะเวลาการจัดการ",
  等级限制: "ข้อจำกัดระดับ",
  托管金额: "จำนวนเงินลงทุน",
  限额: "วงเงินจำกัด",
  余额: "ยอดคงเหลือ",
  购买日: "วันที่ซื้อ",
  起息日: "วันที่เริ่มคิดดอกเบี้ย",
  派息时间: "เวลาจ่ายผลตอบแทน",
  每天: "ทุกวัน",
  计息结束日: "วันที่สิ้นสุดการคิดดอกเบี้ย",
  每日收益: "ผลตอบแทนรายวัน",
  预计收益: "ผลตอบแทนโดยประมาณ",
  "收益将自动发送至您的余额账户;":
    "ผลตอบแทนจะถูกโอนเข้าสู่บัญชียอดคงเหลือของคุณโดยอัตโนมัติ;",
  "您的资金没有任何风险;": "เงินของคุณไม่มีความเสี่ยงใด ๆ;",
  "365*24小时不断地工作;": "ทำงานตลอด 24 ชั่วโมง 365 วัน;",
  托管中: "กำลังจัดการ",
  结束: "สิ้นสุด",
  今日收益: "รายได้วันนี้",
  剩余周期: "ระยะเวลาที่เหลือ",
  进行中: "กำลังดำเนินการ",
  已发放: "จ่ายแล้ว",
  信誉分: "คะแนนชื่อเสียง",

  复制成功: "คัดลอกสำเร็จ",
  VIP权益: "สิทธิพิเศษ VIP",
  旧密码: "รหัสผ่านเก่า",
  请输入旧密码: "กรุณากรอกรหัสผ่านเก่า",
  "忘记旧密码请联系客服重置。":
    "หากคุณลืมรหัสผ่านเก่า กรุณาติดต่อฝ่ายบริการลูกค้าเพื่อรีเซ็ต",
  去升级: "อัปเกรด",
  描述: "คำอธิบาย",
  实际存款金额: "จำนวนเงินฝากจริง",
  升级礼金: "โบนัสอัปเกรด",
  隔夜利息: "ดอกเบี้ยข้ามคืน (สวอป)",
  自动结算: "การชำระบัญชีอัตโนมัติ",
  等级规则: "กฎระเบียบระดับ",
  "WEB3.0币持有数据收益": "ผลตอบแทนจากข้อมูลการถือเหรียญ WEB3.0",
  总生产: "การผลิตทั้งหมด",
  有效节点: "โหนดที่ใช้งาน",
  参与人: "ผู้เข้าร่วม",
  用户收益: "ผลตอบแทนของผู้ใช้",
  "流动性WEB3.0输出": "ผลผลิตสภาพคล่อง WEB3.0",
  总资产: "สินทรัพย์รวม",

  ETHAI持有数据收益: "ผลตอบแทนจากข้อมูลการถือครอง ETHAI",
  AI量化流动性: "สภาพคล่องเชิงปริมาณด้วย AI",
  现货买入手续费: "ค่าธรรมเนียมการซื้อสปอต",
  现货支出: "รายจ่ายสปอต",
  现货资金费率: "อัตราดอกเบี้ยเงินทุนสปอต",
  现货卖出手续费: "ค่าธรรมเนียมการขายสปอต",
  现货收入: "รายรับสปอต",
  外汇合约支出: "รายจ่ายสัญญาฟอเร็กซ์",
  外汇合约买入手续费: "ค่าธรรมเนียมการซื้อสัญญาฟอเร็กซ์",
  外汇合约资金费率: "อัตราดอกเบี้ยเงินทุนสัญญาฟอเร็กซ์",
  外汇合约卖出手续费: "ค่าธรรมเนียมการขายสัญญาฟอเร็กซ์",
  外汇合约收入: "รายรับสัญญาฟอเร็กซ์",
  理财购买: "การซื้อผลิตภัณฑ์จัดการความมั่งคั่ง",
  VIP理财日收益: "ผลตอบแทนรายวันของผลิตภัณฑ์จัดการความมั่งคั่ง VIP",
  VIP理财隔夜利息: "ดอกเบี้ยค้างคืนของผลิตภัณฑ์จัดการความมั่งคั่ง VIP",
  VIP本金返还: "การคืนเงินต้น VIP",
  VIP彩金发放: "การจ่ายโบนัส VIP",
  VIP彩金抵扣: "การหักโบนัส VIP",
  隔夜利息: "ดอกเบี้ยค้างคืน",
  设置资产密码: "ตั้งรหัสผ่านสินทรัพย์",

  锁仓挖矿: "การขุดแบบล็อกเหรียญ",
  一站式理财服务: "บริการการเงินแบบครบวงจร",
  产品: "ผลิตภัณฑ์",
  客服中心: "ศูนย์บริการลูกค้า",
  贷款: "สินเชื่อ",
  挖矿赚不停: "ขุดเหรียญทำรายได้ต่อเนื่อง",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "การขุดแบบล็อกเหรียญคือการฝาก USDT (USD:1USDT=1USD) ให้กับเครื่องขุดพลังประมวลผลสูงของแพลตฟอร์ม เพื่อสร้างผลตอบแทนในพูลการขุดของแพลตฟอร์ม",
  产品优势: "ข้อดีของผลิตภัณฑ์",
  随存随取: "ฝากและถอนเมื่อใดก็ได้",
  锁仓周期: "ระยะเวลาล็อกเหรียญ",
  每日下发: "จ่ายผลตอบแทนรายวัน",
  随机空投: "แอร์ดรอปแบบสุ่ม",
  "100%资金安全保障": "รับประกันความปลอดภัยของเงิน 100%",
  "100%节假日收益不间断": "ผลตอบแทนต่อเนื่อง 100% แม้ในวันหยุด",
  成功锁仓后当天产出: "เริ่มรับผลตอบแทนในวันเดียวกันหลังล็อกสำเร็จ",
  关于违约金: "เกี่ยวกับค่าปรับ",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "หากคุณถอนเงินต้นก่อนครบกำหนด จะมีค่าปรับเกิดขึ้น ค่าปรับ = อัตราค่าปรับ × จำนวนวันที่เหลือ × จำนวนที่ล็อกไว้",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "ตัวอย่าง: อัตราค่าปรับ 5% เหลือ 3 วัน และยอดล็อก 10000U (USDT/USD) ค่าปรับ = 5%×3×10000=1500U และยอดที่ได้รับคืนจริงคือ 15000U-1500U",
  收益计算: "การคำนวณผลตอบแทน",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "แพลตฟอร์มมีผลิตภัณฑ์การเงินแบบล็อกเหรียญหลายรูปแบบให้เลือก การคำนวณผลตอบแทนมีดังนี้ ตัวอย่าง:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "หากผู้ใช้ล็อก 10000U (USDT, USD) และเลือกผลิตภัณฑ์ 7 วัน ที่ให้ผลตอบแทน 0.7%~1.8% ต่อวัน จะได้ผลตอบแทนรายวันดังนี้",
  "最低:10000Ux0.7%=70U;": "ขั้นต่ำ: 10000U×0.7%=70U;",
  "最高:10000Ux1.8%=180U;": "สูงสุด: 10000U×1.8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "เมื่อครบ 7 วัน จะได้รับผลตอบแทน 490U~1260U โดยจ่ายรายวัน และเงินต้นจะโอนเข้าบัญชีอัตโนมัติเมื่อครบกำหนด",
  正在托管的资金: "เงินที่อยู่ในการจัดการ",
  签到: "เช็คอิน",
  锁仓订单: "คำสั่งล็อกเหรียญ",
  预计今日收益: "ผลตอบแทนที่คาดวันนี้",
  累计收益: "ผลตอบแทนสะสม",
  托管中的订单: "คำสั่งที่อยู่ในการจัดการ",
  单笔最少: "ขั้นต่ำต่อรายการ",
  单笔最多: "สูงสุดต่อรายการ",
  日收益率: "อัตราผลตอบแทนรายวัน",
  说明: "คำอธิบาย",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. ข้อมูลอ้างอิงตามเวลา GMT+8<br>2. ผลตอบแทนรายวันคำนวณจากคำสั่งที่ชำระแล้วทั้งหมดในช่วง 00:00-23:59 GMT+8<br>3. ผลตอบแทนจะถูกจ่ายในวันถัดไปช่วง 00:00-00:10 GMT+8",
  知道了: "เข้าใจแล้ว",
  锁仓: "ล็อกเหรียญ",
  派息时间: "เวลาจ่ายผลตอบแทน",
  每日: "รายวัน",
  托管资金: "เงินภายใต้การจัดการ",
  到期返回: "คืนเมื่อครบกำหนด",
  提前赎回: "ถอนก่อนกำหนด",
  预计收益: "ผลตอบแทนที่คาด",
  认购: "สมัคร",
  热门: "ยอดนิยม",
  数字货币: "สกุลเงินดิจิทัล",
  贵金属: "โลหะมีค่า",
  大宗商品: "สินค้าโภคภัณฑ์",
  持仓明细: "รายละเอียดการถือครอง",
  历史明细: "ประวัติ",
  当前价: "ราคาปัจจุบัน",
  "↑买涨": "↑ ซื้อขาขึ้น",
  "↓买跌": "↓ ซื้อขาลง",
  显示全部: "แสดงทั้งหมด",
  买入金额: "จำนวนซื้อ",
  方向: "ทิศทาง",
  收益: "กำไร",
  预期收益: "กำไรที่คาด",
  估用保证金: "มาร์จิ้นโดยประมาณ",
  确认下单: "ยืนยันคำสั่ง",
  锁定: "ล็อกแล้ว",
  账户总资产: "สินทรัพย์รวมในบัญชี",
  明细: "รายละเอียด",
  今日收益: "กำไรวันนี้",
  仓位保证金: "มาร์จิ้นสถานะ",
  持有仓位: "สถานะที่ถืออยู่",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "จำนวนที่ล็อก = ผลรวมของคำสั่งขุดแบบล็อกที่ยังไม่เสร็จทั้งหมด",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. ข้อมูลตามเวลา GMT+8<br>2. ผลตอบแทนรายวันคำนวณจากคำสั่งที่ชำระแล้วทั้งหมด",
  充值方式: "วิธีฝากเงิน",
  银行汇款: "โอนเงินผ่านธนาคาร",
  "银行汇款请联系客服进行操作!":
    "กรุณาติดต่อฝ่ายบริการลูกค้าเพื่อทำรายการโอนเงินผ่านธนาคาร",
  提款方式: "วิธีถอนเงิน",
  "银行提款请联系客服进行操作!":
    "กรุณาติดต่อฝ่ายบริการลูกค้าเพื่อทำรายการถอนเงินผ่านธนาคาร",
  资金明细: "รายละเอียดเงินทุน",
  提现记录: "ประวัติการถอนเงิน",
  拒绝: "ปฏิเสธ",
  通过: "อนุมัติ",
  拒绝原因: "เหตุผลการปฏิเสธ",

  消息公告: "ประกาศ",
  订单: "คำสั่งซื้อ",
  个人中心: "ศูนย์ส่วนบุคคล",
  "未到期赎回需支付一定的违约金!": "การไถ่ถอนก่อนครบกำหนดต้องชำระค่าปรับ",
  请输入区号: "กรุณากรอกรหัสพื้นที่",
  "请选择国家/地区": "กรุณาเลือกประเทศ/ภูมิภาค",

  今日开盘: "เปิดวันนี้",
  昨日收盘: "ปิดเมื่อวาน",

  实名认证即送: "รับทันทีหลังจากยืนยันตัวตน",
  立即认证: "ยืนยันตอนนี้",
  新用户礼包: "แพ็กเกจของขวัญสำหรับผู้ใช้ใหม่",
  完成新人任务领取: "ทำภารกิจสำหรับผู้ใช้ใหม่ให้สำเร็จเพื่อรับ",
  认证: "ยืนยัน",
  时间周期: "ระยะเวลา",
  支付金额: "จำนวนเงินที่ชำระ",
  已平仓: "ปิดสถานะแล้ว",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "แพ็กเกจต้อนรับผู้ใช้ใหม่ MGBX: ผู้ใช้แต่ละรายสามารถรับได้สูงสุด",
  我已经阅读并同意: "ฉันได้อ่านและยอมรับ",
  隐私政策: "นโยบายความเป็นส่วนตัว",

  放弃奖励离开: "สละรางวัลและออก",
  继续注册: "ดำเนินการลงทะเบียนต่อ",
  分钟: "นาที",

  "请先勾选隐私政策!": "โปรดตรวจสอบนโยบายความเป็นส่วนตัวก่อน!",

  添加其他到自选: "เพิ่มรายการอื่นลงในรายการที่เฝ้าติดตาม",

  充值最高可得: "เติมเงินและรับสูงสุด 30,000 ดอลลาร์",

  请输入格式正确的手机号: "กรุณาระบุหมายเลขโทรศัพท์มือถือที่ถูกต้อง",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 泰语



// WEBPACK FOOTER //
// ./src/lang/th.js